<template>
  <v-app v-resize="onResize">
    <v-app-bar
      app
      :style="cordovaApp ? 'height: 95px' : ''"
      color="primary"
      dark
      :class="cordovaApp ? 'pt-10' : ''"
    >
      <v-app-bar-nav-icon large class="d-flex d-md-none" variant="text" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <div class="d-none d-md-flex">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">  
            <v-btn text v-bind="attrs" v-on="on" @click.stop="showPageOne"><v-icon large>{{ (webApp && (vfPage == 1)) ? 'mdi-exit-run' : 'mdi-home' }}</v-icon></v-btn>
          </template>
          {{$t((webApp && (vfPage == 1)) ? 'message.navbar.exit' : 'message.navbar.homeAbout')}}
        </v-tooltip>        
        <v-tooltip bottom v-if="currentTrip.id">
          <template v-slot:activator="{ on, attrs }">  
            <v-btn text v-bind="attrs" v-on="on" @click.stop="showPage(2, true)"><v-icon large>mdi-view-list</v-icon></v-btn>
          </template>
          {{$t('message.navbar.operations')}}
        </v-tooltip>
        <v-tooltip bottom v-if="payments.length">
          <template v-slot:activator="{ on, attrs }">  
            <v-btn text v-bind="attrs" v-on="on" @click.stop="showPage(3, true)"><v-icon large>mdi-poll</v-icon></v-btn>
          </template>
          {{$t('message.navbar.statisticsTitle')}}
        </v-tooltip>          
        <v-tooltip bottom v-if="!dataReadonly && (travellers.length > 1) && (flag & (flags.writeMy | flags.writeAll))">
          <template v-slot:activator="{ on, attrs }">  
            <v-btn text v-bind="attrs" v-on="on" @click.stop="openDialogNewPayment"><v-icon large>mdi-plus-box</v-icon></v-btn>
          </template>
          {{$t('message.navbar.addPayment')}}
        </v-tooltip>          
        <v-tooltip bottom v-if="!dataReadonly && (flag & flags.master)">
          <template v-slot:activator="{ on, attrs }">            
            <v-btn text v-bind="attrs" v-on="on" @click.stop="openDialogTravellers"><v-icon large>mdi-account-multiple</v-icon></v-btn>
          </template>
          {{$t('message.navbar.travellers')}}
        </v-tooltip>          
        <v-tooltip bottom v-if="!dataReadonly && (flag & flags.banker)">
          <template v-slot:activator="{ on, attrs }">            
            <v-btn text v-bind="attrs" v-on="on" @click.stop="openDialogCurrencys"><v-icon large>mdi-cash-multiple</v-icon></v-btn>
          </template>
          {{$t('message.navbar.currency')}}
        </v-tooltip>          
        <v-tooltip bottom v-if="(config.master && config.maxMasters) || trips.length">
          <template v-slot:activator="{ on, attrs }">          
            <v-btn text v-bind="attrs" v-on="on" @click.stop="openDialogSettings"><v-icon large>mdi-hiking</v-icon></v-btn>
          </template>
          {{$t('message.navbar.trips')}}
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">          
            <v-btn text v-bind="attrs" v-on="on" @click.stop="openDialogAccount"><v-icon large>mdi-cog</v-icon></v-btn>
          </template>
          {{$t('message.navbar.account')}}
        </v-tooltip>
        <template v-if="cordovaApp">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">          
              <v-btn text v-bind="attrs" v-on="on" @click.stop="showPage(4)"><v-icon large>mdi-qrcode-scan</v-icon></v-btn>
            </template>
            {{$t('message.navbar.qrScan')}}
          </v-tooltip>
        </template>
      </div>
      <v-spacer></v-spacer>

      <v-tooltip bottom v-if="vConsoleWebAllow">
        <template v-slot:activator="{ on, attrs }">   
          <v-btn text v-bind="attrs" v-on="on" @click.stop="cons">
            <v-icon large>mdi-eye</v-icon>
          </v-btn>
        </template>
        {{$t('message.navbar.logRemote')}}
      </v-tooltip>

      <v-tooltip bottom v-if="consoleAllow">
        <template v-slot:activator="{ on, attrs }">   
          <v-btn text v-bind="attrs" v-on="on" @click.stop="consoleAllow = false">
            <v-icon large>mdi-text</v-icon>
          </v-btn>
        </template>
        {{$t('message.navbar.logRemote')}}
      </v-tooltip>      

      <template v-if="!!masterMode">
        <template v-if="payments.length">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">   
              <v-btn text v-bind="attrs" v-on="on" @click.stop="privateBudget = !privateBudget">
                <v-icon v-if="privateBudget" large>mdi-home-import-outline</v-icon>
                <v-icon v-else color="blue lighten-1" large>mdi-home-import-outline</v-icon>
              </v-btn>
            </template>
            {{$t('message.operationList.privateIncluded')}}
          </v-tooltip>
        </template>

        <v-tooltip bottom v-if="false && dataReadonly">
          <template v-slot:activator="{ on, attrs }">   
            <v-btn text v-bind="attrs" v-on="on" @click.stop="apiOn">
              <v-icon large color="amber">mdi-link-variant-off</v-icon>
            </v-btn>
          </template>
          {{$t('message.navbar.disconnected')}}
        </v-tooltip>

        <v-tooltip bottom v-if="false && !dataReadonly">
          <template v-slot:activator="{ on, attrs }">   
            <v-btn text v-bind="attrs" v-on="on">
              <v-icon large>mdi-link-variant</v-icon>
            </v-btn>
          </template>
          {{$t('message.navbar.online')}}
        </v-tooltip>
      </template>
      <v-menu offset-y class="mt-0">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            text
            v-bind="attrs"
            v-on="on"
          >
            <span class="text-h6">{{ locales[locale].text }}</span>
          </v-btn>
        </template>
        <v-list>
          <template v-for="(item, index) in activeLocales">
            <v-list-item     
              v-if="item.valid"       
              :key="index"
              @click="setLocale(item.id)"
            >
              <v-list-item-title :color="item.hidden ? 'grey lighten-2' : 'black'">{{ item.text }}</v-list-item-title>
            </v-list-item>
          </template>
        </v-list>
      </v-menu>   
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      app
      top
      temporary
      class="pt-0"
    >
      <template v-slot:prepend>
        <v-list-item :class="'blue lighten-5 pb-0 mb-0 ' + (cordovaApp ? 'pt-10' : 'pt-2')">
          <img src="./assets/logo2.svg" style="width: 60%;">
        </v-list-item>       
        <v-list-item class="blue lighten-5 py-0 my-0 tripcount-logo">
          Tripcount
        </v-list-item>               
        <v-list-item two-line v-if="currentTrip.id">
          <v-list-item-content>
            <v-list-item-title>
              {{ currentTrip.name }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ (masterMode > 0) ? 
                'Master' : (getTravellerBySlave() ? 
                  getTravellerBySlave().name 
                  : 'Unknown') }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>

      <v-divider></v-divider>

      <v-list
        nav
        dense
        flat
      >
        <v-list-item-group
          v-model="group"
        >
          <v-list-item @click.stop="showPageOne" id="drw-1" class="py-0">
            <v-list-item-icon>
              <v-icon class="primary--text">{{ (webApp && (vfPage == 1)) ? 'mdi-exit-run' : 'mdi-home' }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title><span class="text-body-1 primary--text">{{$t((webApp && (vfPage == 1)) ? 'message.navbar.exit' : 'message.navbar.homeAbout')}}</span></v-list-item-title>
          </v-list-item>

          <v-list-item v-if="currentTrip.id" @click.stop="showPage(2, true)" id="drw-2" class="py-0">
            <v-list-item-icon>
              <v-icon class="primary--text">mdi-view-list</v-icon>
            </v-list-item-icon>              
            <v-list-item-title><span class="text-body-1 primary--text">{{$t('message.navbar.operations')}}</span></v-list-item-title>
          </v-list-item>

          <v-list-item v-if="payments.length" @click.stop="showPage(3, true)" id="drw-3" class="py-0">
            <v-list-item-icon>
              <v-icon class="primary--text">mdi-poll</v-icon>
            </v-list-item-icon>              
            <v-list-item-title><span class="text-body-1 primary--text">{{$t('message.navbar.statistics')}}</span></v-list-item-title>
          </v-list-item>

          <template v-if="!dataReadonly">

            <v-list-item v-if="(travellers.length > 1) && (flag & (flags.writeMy | flags.writeAll))" @click.stop="openDialogNewPayment" class="py-0">
              <v-list-item-icon>
                <v-icon class="primary--text">mdi-plus-box</v-icon>
              </v-list-item-icon>              
              <v-list-item-title><span class="text-body-1 primary--text">{{$t('message.navbar.addPayment')}}</span></v-list-item-title>
            </v-list-item>

            <v-list-item v-if="flag & flags.master" @click.stop="openDialogTravellers" class="py-0">
              <v-list-item-icon>
                <v-icon class="primary--text">mdi-account-multiple</v-icon>
              </v-list-item-icon>                  
              <v-list-item-title><span class="text-body-1 primary--text">{{$t('message.navbar.travellers')}}</span></v-list-item-title>
            </v-list-item>

            <v-list-item v-if="flag & flags.banker" @click.stop="openDialogCurrencys" class="py-0">
              <v-list-item-icon>
                <v-icon class="primary--text">mdi-cash-multiple</v-icon>
              </v-list-item-icon>                  
              <v-list-item-title><span class="text-body-1 primary--text">{{$t('message.navbar.currency')}}</span></v-list-item-title>
            </v-list-item>
          </template>

          <v-list-item @click.stop="openDialogSettings" v-if="(config.master && config.maxMasters) || trips.length" class="py-0">
              <v-list-item-icon>
                <v-icon class="primary--text">mdi-hiking</v-icon>
              </v-list-item-icon>                
            <v-list-item-title><span class="text-body-1 primary--text">{{$t('message.navbar.trips')}}</span></v-list-item-title>
          </v-list-item>

          <v-list-item @click.stop="openDialogAccount" class="py-0">
              <v-list-item-icon>
                <v-icon class="primary--text">mdi-cog</v-icon>
              </v-list-item-icon>                
            <v-list-item-title><span class="text-body-1 primary--text">{{$t('message.navbar.account')}}</span></v-list-item-title>
          </v-list-item>

          <v-list-item v-if="cordovaApp" @click.stop="showPage(4)" id="drw-4" class="py-0">
              <v-list-item-icon>
                <v-icon class="primary--text">mdi-qrcode-scan</v-icon>
              </v-list-item-icon>
            <v-list-item-title><span class="text-body-1 primary--text">{{$t('message.navbar.qrScan')}}</span></v-list-item-title>
          </v-list-item>

        </v-list-item-group>
      </v-list>
      <v-list-item v-if="cordovaApp" class="blue lighten-5 pb-0">
        <img width="50%" src="../src/assets/google_play.svg"/>
      </v-list-item>
      <v-list-item class="blue lighten-5 pb-0">
        <img width="40%" src="../src/assets/visa_master.svg"/>
      </v-list-item>      
      <v-list-item class="pt-0 footer-text grey--text text--lighten-1">
        Tripcount {{version}}<br/>© LaFuente 2023<br/>Build {{engine_version}}
      </v-list-item>
    </v-navigation-drawer>
    <v-main class="px-0 mx-0">
      <div style="height: 100%, background-color: #1976D2"
        v-show="vfPage == -1" >
      </div>
      <about-info 
        v-show="vfPage == 1" 
        :config="config"
        :urls="urls"
        @agree="docDialogAgree"
        @account="openDialogAccount"
        @console="vConsoleTo"
        @invite="slaveConfirmEvent"
        @bull="bull">
      </about-info> 
      <payment-stat 
        v-model="privateBudget" 
        v-show="vfPage == 3" 
        :payments="payments" 
        :payTable="payTable" 
        :lbls="lbls" 
        :travellers="travellers" 
        :apiBusy="apiBusy"
        :balanceCurrency="currencys[currencys[0].id].name"
        @bull="bull">
      </payment-stat>
      <qr-scanner
        v-if="cordovaApp"
        v-show="vfPage == 4"
        :ready="vfPage == 4"
        @scan="qrScan"
        @console="vConsoleTo">
      </qr-scanner>      
      <payment-list 
        ref="childPaymentList" 
        v-scroll="onScrollList" 
        v-model="privateBudget" 
        v-show="vfPage == 2" 
        :active="vfPage == 2" 
        @expandOpen="dialogsPayments" 
        @carouselOpen="dialogsPayments"
        @refund="openDialogRefund" 
        @change="payEditSave" 
        @delete="deletePayment" 
        @make-xls="makeXls"
        @bull="bull"
        :vKeyboard="vKeyboard" 
        :dataReadonly="dataReadonly" 
        :apiBusy="apiBusy"
        :shareds="shareds" 
        :transactions="transactions" 
        :transactionsRefund="transactionsRefund" 
        :lbls="lbls" 
        :payments="payments" 
        :payTable="payTable"
        :currencys="currencys"
        :slave="slave"
        :flag="flag"
        :config="config"        
        :travellers="travellers"
        :userColors="userColors"
        :cordovaApp="cordovaApp">
      </payment-list>
      <payment-add 
        ref="childPaymentAdd" 
        v-model="formAdd"
        v-if="flag & (flags.writeMy | flags.writeAll)"
        :vKeyboard="vKeyboard" 
        :lbls="lbls" 
        :shareds="shareds" 
        :travellers="travellers" 
        :currencys="currencys" 
        :transactions="transactions" 
        :slave="slave"
        :flag="flag"
        :privateBudget="privateBudget"
        :cordovaApp="cordovaApp"
        @save="addPayment"
        @bull="bull"
        :userColors="userColors">
      </payment-add>
      <payment-refund 
        ref="childPaymentRefund" 
        v-model="formRefund"
        :vKeyboard="vKeyboard"
        :transactionsRefund="transactionsRefund"
        :lbls="lbls"
        :shareds="shareds"
        :travellers="travellers" 
        :currencys="currencys"
        :flag="flag"
        @save="addPayment" 
        @bull="bull"
        :pay="payToRefund"
        :userColors="userColors">
      </payment-refund>
      <travellers-edit
        ref="childTravellersEdit"
        v-model="formTravellers" 
        v-if="flag & flags.master"
        @resample="payTableCreate"
        @change="travellersSave" 
        @add="travellerAdd"
        @del="travellerDel"
        @invite="slaveInvite"
        @bull="bull"
        :balance="balance"
        :currencys="currencys" 
        :cordovaApp="cordovaApp"
        :changeAllowed="!payments.length"
        :vKeyboard="vKeyboard" 
        :travellers="travellers"
        :slave="slave"
        :flag="flag"
        :userColors="userColors">
      </travellers-edit>
      <currency-edit 
        ref="childCurrencyEdit"
        v-model="formCurrencys" 
        v-if="flag & flags.banker"
        :vKeyboard="vKeyboard" 
        :currencys="currencys" 
        :finalFixed="!!payments.length"
        @change="currencySave"
        @bull="bull"
        :flag="flag">
      </currency-edit>
      <settings-edit 
        ref="childSettings" 
        v-model="formSetings" 
        @trip-new="addNewTrip"
        @trip-change="settingsSave"
        @trip-select="settingsTripSelect"
        @trip-delete="deleteTrip"
        @make-xls="makeXls"
        @bull="bull"
        :vKeyboard="vKeyboard"
        :paymentsTable="payTable" 
        :travellers="travellers"        
        :config="config"
        :trips="trips">
      </settings-edit>
      <account-edit 
        ref="childAccount" 
        v-model="formAccount" 
        :vKeyboard="vKeyboard"
        :config="config"
        :account="account"
        @masterRegister="masterRegister"
        @pay="liqpayStart"
        @email="emailSave"
        @wipe="wipeAccount"
        @bull="bull"
        @agree="docDialogAgree"
        @console="vConsoleTo">
      </account-edit>      
      <div v-if="false" v-html="apiCheckInfo"></div>
      <template v-if="vConsoleAllow">
        <br/>BEGIN CONSOLE <br/><div id="v-console" v-html="vConsole"></div><br/>END CONSOLE<br/><br/><br/><br/>
      </template>
      <v-snackbar
        v-model="snackbarAddPayment"
        color="primary"
        timeout="-1"
        transition="scale-transition"
        rounded="pill"
        bottom center
        elevation="8"
        max-height="50"
        class="mb-12"
        style="opacity:0.6"
      >
        <h2 class="text-center pointer" @click.stop="openDialogNewPayment">
          <v-icon large color="white" >mdi-plus-box</v-icon>&nbsp;&nbsp;{{ $t("message.navbar.addPayment") }}
        </h2>
      </v-snackbar>        
      <v-dialog v-model="dialogLiqpay.model" persistent width="500">
        <v-card>
          <v-card-title class="primary vf-add-payment">
            {{$t('message.reg.liqpayTitle')}}
            <v-spacer/>
          </v-card-title>
          <v-card-text class="px-5">
            <v-row class="ma-0 pa-0">
              <v-spacer/>
              <v-col cols="6" class="mt-4">
                <img width="100%" src="../src/assets/lp.svg"/>
                <img width="100%" src="../src/assets/visa_master.png"/>
              </v-col>
              <v-spacer/>
              <v-col cols="12" class="ma-0 pa-0">
                {{ parseSplit($t('message.reg.liqpayInfo'),0) }}
                <a href="https://liqpay.ua">{{ parseSplit($t('message.reg.liqpayInfo'),1) }}</a>
                {{ parseSplit($t('message.reg.liqpayInfo'),2) }}
                <a href="https://privatbank.ua/">{{ parseSplit($t('message.reg.liqpayInfo'),3) }}</a>
                {{ parseSplit($t('message.reg.liqpayInfo'),4) }}
                <v-simple-table>
                  <tbody>
                    <tr>
                      <td>{{ $t('message.reg.order') }}</td><td>{{dialogLiqpay.data.order}}</td>
                    </tr>
                    <tr>
                      <td>{{ $t('message.reg.amount') }}</td><td>{{dialogLiqpay.data.amount}} UAH</td>
                    </tr>                    
                  </tbody>
                </v-simple-table>
              </v-col>
            </v-row>
            <form id="liqpay-form" method="POST" :action="dialogLiqpay.data.url" accept-charset="utf-8">
              <input type="hidden" name="signature" :value="dialogLiqpay.data.signature">
              <input type="hidden" name="data" :value="dialogLiqpay.data.data">
            </form>
          </v-card-text>
          <v-divider class="mt-3"></v-divider>
          <v-card-actions class="mt-0 pt-0 mx-2">                    
            <v-spacer/>
            <v-btn class="my-4" color="primary" elevation="4" @click.stop="liqpayPay">{{$t('message.reg.pay')}}</v-btn>
            <v-btn class="my-4" color="primary" elevation="4" @click.stop="dialogLiqpay.model = false">{{$t('message.cancel')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>     
      <v-dialog v-model="dialogInfo.model" persistent width="500">
        <v-card>
          <v-card-title class="primary vf-add-payment">
            {{dialogInfo.title}}
            <v-spacer/>
          </v-card-title>
          <v-card-text class="px-5">
            <v-row class="ma-0 pa-0 ">
              <v-col cols="12" class="mt-8 mb-0 pa-0">
                <div v-html="dialogInfo.body">
                </div>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider class="mt-3"></v-divider>
          <v-card-actions>
            <v-btn v-if="!!dialogInfo.ok && !dialogInfo.okIcon" class="my-4" color="primary" elevation="4" @click.stop="dialogInfo.ok">
              {{dialogInfo.okTitle}}
            </v-btn>
            <v-btn v-if="!!dialogInfo.ok && !!dialogInfo.okIcon" class="my-4" color="primary" elevation="4" @click.stop="dialogInfo.ok">
              <v-icon>{{dialogInfo.okIcon}}</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn class="my-4" color="primary" elevation="4" @click.stop="dialogInfo.close">{{dialogInfo.closeTitle ? dialogInfo.closeTitle : $t('message.close')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogLiqpayd.model" persistent width="500">
        <v-card>
          <v-card-title class="primary vf-add-payment">
            {{$t('message.reg.processTitle')}}
            <v-spacer/>
          </v-card-title>
          <v-card-text class="px-5">
            <v-row class="ma-0 pa-0">
              <v-col cols="12" class="mt-8 mb-0 pa-0">
                <h3 class="text-center mb-5" v-html="$t('message.reg.orderId') + dialogLiqpayd.order"></h3>
                <h1 class="text-center blue--text text--darken-2" v-if="dialogLiqpayd.status == 1">{{$t('message.reg.dispose')}}</h1>
                <h1 class="text-center blue--text text--darken-2" v-if="dialogLiqpayd.status == 2">{{$t('message.reg.complete')}}</h1>
              </v-col>
            </v-row>                
            <v-row class="ma-0 pa-0">
              <v-col cols="12" class="ma-0 pa-0 text-center">
                <v-progress-circular
                  v-if="dialogLiqpayd.counter"
                  :rotate="270"
                  :size="180"
                  :width="30"
                  :value="100-10*dialogLiqpayd.counter"
                  color="primary">
                  <h1>{{dialogLiqpayd.counter}}</h1>
                </v-progress-circular>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider class="mt-3"></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="my-4" color="primary" :disabled="dialogLiqpayd.status == 0" elevation="4" @click.stop="appRefresh">{{$t('message.close')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>                  
      <v-dialog v-model="dialogReadonly" persistent width="500">
        <v-card>
          <v-card-title class="primary vf-add-payment">
            {{$t('message.connectionError')}}
            <v-spacer/>
          </v-card-title>
          <v-card-text>
            <h2 class="text-center my-4">{{$t('message.possibleReasons')}}:</h2>
            <ul>
              <li>{{$t('message.possibleReason1')}}</li>
              <li>{{$t('message.possibleReason3')}}</li>
            </ul>
          </v-card-text>
          <v-divider class="mt-3"></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="my-4" color="primary" elevation="4" @click.stop="dialogReadonlyRetry">{{$t('message.tryAgain')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>     
    </v-main>
    <v-dialog 
      style="text-align: center"
      v-model="apiBusy" 
      persistent 
      fullscreen>
      <v-overlay 
        :value="true"
        :opacity="0.75"
        color="black"
        z-index="100"
        >
          <v-progress-circular
            style="opacity: 0.6"
            :size="300"
            :width="60"
            color="white"
            indeterminate 
          ></v-progress-circular>     
      </v-overlay> 
    </v-dialog>
    <v-footer dark fixed color="primary" padless>
      <v-row>
        <v-col cols="87" class="footer-text my-2 mx-4 text-left">
          {{currentTrip.id ? 
            (currentTrip.name + ' • ' + ((masterMode > 0) ? 
              'Master' 
              : (getTravellerBySlave() ? 
                getTravellerBySlave().name 
                : ' ... '))) 
            : ('Tripcount '+version+ ' © LaFuente 2023')}}
        </v-col>

        <v-col cols="4" v-if="!(cordovaApp || webApp)" class="my-2 mx-0 text-right">
          <v-icon v-if="!dialogsNotOpened">mdi-account-tag</v-icon>
          <v-icon @click.stop="cordovaPause">mdi-close-box</v-icon>
          <v-icon @click.stop="cordovaResume">mdi-close-box</v-icon>
          <v-icon @click.stop="consoleAllow = !consoleAllow">mdi-close-box</v-icon>
          <v-icon @click.stop="cons">mdi-close-box</v-icon>
          <v-icon @click.stop="wipe">mdi-close-box</v-icon> &nbsp;
        </v-col>
      </v-row>
    </v-footer>
  </v-app>
</template>

<script>
const MSG_FLAG_CONFIRM = 4;
const MSG_FLAG_REFRESH = 128;
const MSG_FLAG_NOCONFIRM = 256;
const LOG_INTENT = 1;
const LOG_CONFIG = 2;
const LOG_EXTRA_DATA = 4;
const API_BUSY_DELAY = 1000;
//const PAYMENT_STATUS_INIT = 1;
//const PAYMENT_STATUS_HELD = 2;
const PAYMENT_STATUS_PAYD = 3;
const PAYMENT_STATUS_FAULT = 4;
//const PAYMENT_STATUS_REFUND = 5;
const PAYMENT_STATUS_PENDING = 6;
const PAYMENT_STATUS_UNKNOWN = 10;

let shajs = require("sha.js");
import { CDNavigator, CDMedia, cordovaApp, webApp, appVersion, uiVersion, CDCordova, CDDevice, CDLocalFileSystem, CDPurchase, CDPurchases, CDLocale } from "./components/cordova.js";
import { defs } from "./components/defaults.js";
import { apiSubscribe, apiSetup, apiUnsubscribe, apiPush, api, apiSet, apiWipe, apiStackDepth, apiLoggerSet, apiWebLog, apiSleep, apiPing } from "./Api4.js";
import QrScanner from './components/QrScanner';
import PaymentList from './components/PaymentList';
import PaymentAdd from './components/PaymentAdd';
import PaymentRefund from './components/PaymentRefund';
import PaymentStat from './components/PaymentStat';
import TravellersEdit from './components/TravellersEdit';
import CurrencyEdit from './components/CurrencyEdit';
import SettingsEdit from './components/SettingsEdit';
import AccountEdit from './components/AccountEdit';
import AboutInfo from './components/AboutInfo';

export default {
  name: 'App',

  components: {
    PaymentList,
    PaymentAdd,
    PaymentRefund,
    TravellersEdit,
    CurrencyEdit,
    SettingsEdit,
    AccountEdit,
    AboutInfo,
    PaymentStat,
    QrScanner
  },

  data : () => {
    return {
      version: appVersion,
      engine_version: uiVersion,
      shajs: shajs,
      vConsole: '',
      vConsoleBuffer: [],
      consoleAllow: (cordovaApp || webApp) ? false : true,
      webConsoleRdy: false,      
      vConsoleAllow: false,
      vConsoleWebAllow: false,
      vConsoleChannels: [0,1,2,3,4,10,11,12,13,14,20,21,99],
      vConsoleChannelsColor: {
        0: 'black', 
        1: 'blue', 
        2: '#008080', 
        3: 'red' , 
        4: '#600000', 
        10: '#008000', 
        11: 'red' , 
        12: "#800080", 
        13: "red", 
        14: "red", 
        20: "#000040", 
        21: "black", 
        99: "#000080"},
      /*
      console channels:
      0 - unsorted
      1 - intent, url process, registrations & invitations
      2 - config changes
      3 - lifetime app points
      4-  extra data via api
      10 - API low level
      11 - API errors
      12 - API high level
      13 - connections
      14 - File System
      20 - Cordova timer
      21 - Liqpay, RevenueCat and others Payments
      99 - console service
      */
      appMounted: false,
      vKeyboard: false,
      cordovaUrl: {},
      cordovaApp: cordovaApp,
      webApp: webApp,
      cordovaReady: false,
      revenueCat: null,          // revenueCat Purchases object
      revenueCatPacks: [],       // Pricelist from revenue
      // cordovaSound: null,
      cordovaQrSound: null,
      cordovaBulSound: null,
      // cordovaTsSound: null,
      // cordovaSoundAllow: false,
      cordovaFileEntry: {},
      cordovaIntentFlag: false,
      startingUrlProcessed: false,
      scrollListTimer: null,      // Таймер после остановки прокрутки
      scrollListDelay: 1000,      // Задержка таймера
      scrollList: false,          // Флаг прокрутки в процессе + пауза
      compact: 0,
      vfPage : -1,
      locale : 0,
      currentTrip : {},
      masterMode : 0,
      trips: [],
      slave: 0,      
      flag: 31,      
      drawer : false,
      drawerValue : 0,
      group : null,
      appRefreshed : (typeof APP_REBOOT == 'undefined') ? false : true,   // блокирует intent
      formAdd : 0,
      formTravellers : 0,
      formCurrencys : 0,
      formRefund : 0,
      formSetings: 0,
      formAccount: 0,
      formsPayments : false,    

      apiBusy: false,
      apiBusyTrigger: true,
      payToRefund : null,    
      dialogReadonly : false,
      dataReadonly : true,
      apiStatementValue: 0,
      privateBudget : true,
      account: defs.account,
      payments: [],
      // paymentsTable: [],
      // paymentsTableProcess: 0,
      configVersion: 3,
      config: defs.config,
      locales: defs.locales,
      apiLocker: true,          // Блокирует принятие данных в процессе их же редакции
      refreshApiTrigger: true,  // Требуется полная перезагрузка в случае ошибок API
      intentTrigger: true,      // разрешение на обработку URL
      qrTrigger: false,         // Разрешение на обработку скана
      qrSleepTrigger: false,    // Разрешение на блокировку события Pause из-за запроса на разрешение камеры при QR сканировании
      qrWekeUpTrigger: false,   // Разрешение на блокировку события Resume из-за запроса на разрешение камеры при QR сканировании

      transactionsBase: defs.transactions,
      transactionsRefundBase: defs.transactionsRefund,
      travellers: defs.travellers,
      currencys: defs.currencys,
      lblsBase : defs.labels,
      sharedsBase: defs.shareds,
      flags: defs.slaveFlags,
      flagsUp: defs.slaveFlagsUp,
      tripObserver: false,
      apiCheckInfo: '',

      invitation: null,
      dialogInfo: {
        model: false,
        title: '',
        body: '',
        okTitle: 'Ok',
        okIcon: null,
        ok: null,
        close: null,
        open: null,
        closeTitle: null
      },
      dialogLiqpay: {
        model: false,
        data: {}
      },
      dialogLiqpayd: {
        model: false,
        order: 0,
        counter: 10,
        status: 0
      },
      agreements: [{
        title: 'doc.confidenceAgreementTitle',
        body: 'doc.confidenceAgreement',
        text: 'confidenceAgreementUA',
        type: 'conf'
      },
      {
        title: 'doc.userAgreementTitle',
        body: 'doc.userAgreement',
        text: 'userAgreementUA',
        type: 'user'
      }],      
      confidenceAgreementUA: "<h2 class=\"doc primary--text\">1. Вступ</h2><p class=\"doc\">1.1. Конфіденційність користувачів нашого веб-сайту та мобільного додатку має велике значення для нас, і ми докладаємо всіх зусиль для забезпечення її захисту. Дані правила пояснюють, як ми використовуємо вашу персональну інформацію.</p><p class=\"doc\">1.2. Наш веб-сайт та мобільний додаток використовують файли-cookie для ідентифікації користувачів та локального збереження поточної інформації. Ми не використовуємо файли-cookies, які застосовуються для маркетингового аналізу та цільовій реклами.</p><p class=\"doc\">1.3. Ця угода може бути перекладена іншою мовою. У разі будь-яких розбіжностей у тлумаченні мовних версій угоди, перевагу має документ, викладений українською.</p><h2 class=\"doc primary--text\">2. Права інтелектуальної власності</h2><p class=\"doc\">2.1. Цей документ був створений з використанням шаблона із сайту SEQ Legal (www.seqlegal.com) та модифікованого шаблону з веб-сайта Website Planet (www.websiteplanet.com)</p><h2 class=\"doc primary--text\">3. Збір персональних даних</h2><p class=\"doc\">3.1. Збору, зберіганню та використанню підлягають наступні типи персональних даних:</p><p class=\"doc\">3.1.1. Інформація про ваш комп’ютер або мобільний прилад, а саме вашу IP-адресу та uuid-ідентифікатор приладу;</p><p class=\"doc\">3.1.1. Інформація про адресу вашої електронної пошти, яку ви використали для реєстрації на нашому веб-сайті або у додатку;</p><p class=\"doc\">3.1.3. Інформація, яку ви ввели під час створення даних на нашому веб-сайті або у додатку – ваше умовне ім’я, обрану мову інтерфейсу, умовні імена інших учасників вашого заходу, дані про усі фінансові операції з купівлі товарів та послуг, які ви забажали зареєструвати з метою обліку та подальшої обробки;</p><p class=\"doc\">3.1.4. Інформація, яка генерується при використанні нашого веб-сайту або додатку, включаючи інформацію про дату та час створення, модифікації та отримання даних;</p><p class=\"doc\">3.1.5. Інформація стосовно транзакцій покупок наших послуг по збереженню та обробці даних, які ви провели через наш веб-сайт або додаток, включаючи вашу адресу електронної поштової скриньки та часткову інформацію про платіжну карту;</p><p class=\"doc\">3.1.6. Будь-яка інша персональна інформація, яку ви надіслали нам за власною ініціативою.</p><p class=\"doc\">3.2. Перед тим, як розкрити для нас персональну інформацію третьої особи, ви маєте отримати згоду цієї особи як на розкриття, так і на обробку цієї інформації у відповідності до даних правил.</p><h2 class=\"doc primary--text\">4. Використання вашої персональної інформації</h2><p class=\"doc\">4.1. Персональна інформація, яку ви передали нам через наш веб-сайт або додаток, буде використовуватися задля цілей, зазначених в цих правилах або на відповідних сторінках веб-сайту чи додатку. Ми можемо використовувати вашу персональну інформацію в наступних цілях:</p><p class=\"doc\">4.1.1. адміністрування нашого веб-сайту та додатку;</p><p class=\"doc\">4.1.2. персоналізація нашого веб-сайту та додатку для вас;</p><p class=\"doc\">4.1.3. надання вам можливості користуватися сервісами, доступними на нашому веб-сайті та у додатку;</p><p class=\"doc\">4.1.4. надання вам послуг, придбаних через наш веб-сайт або додаток;</p><p class=\"doc\">4.1.5. надсилання вам повідомлень, рахунків та нагадувань про сплату, та отримання платежів від вас;</p><p class=\"doc\">4.1.6. надсилання вам немаркетингових комерційних повідомлень;</p><p class=\"doc\">4.1.7. надсилання вам електронною поштою повідомлень, які ви спеціально запросили;</p><p class=\"doc\">4.1.8. надсилання вам маркетингових повідомлень стосовно нашої ділової активності;</p><p class=\"doc\">4.1.9. обробка запитів та скарг, зроблених вами і які стосуються нашого веб-сайту або додатку;</p><p class=\"doc\">4.1.10. з метою забезпечення безпеки нашого сайту та додатку та попередження шахрайства;</p><p class=\"doc\">4.1.11. з метою перевірки відповідності умовам та правилам, які регламентують використання нашого веб-сайту та додатку (включаючи моніторинг приватних повідомлень, надісланих через сервіс приватних повідомлень нашого веб-сайту);</p><p class=\"doc\">4.1.12. та в інших цілях, які явно передбачені діючим законодавством України.</p><p class=\"doc\">4.2. Ми не використовуємо вашу персональну інформацію для публікації на нашому веб-сайті або у додатку, для надсилання вам маркетингових повідомлень стосовно ділової активності сторонніх компаній або надання стороннім компаніям інформації про наших користувачів. </p><p class=\"doc\">4.3. Без вашої чітко вираженої згоди ми не будемо передавати вашу персональну інформацію жодній сторонній компанії для прямого маркетингового використання цією, або будь-якою іншою сторонньою компанією.</p><h2 class=\"doc primary--text\">5. Розкриття персональної інформації</h2><p class=\"doc\">5.1. Ми лишаємо за собою право розкрити вашу персональну інформацію для будь-якого з наших працівників, керівників, страхувальників, професійних радників, агентів, постачальників або субпідрядників, в об’ємі та цілях, визначених в цих правилах.</p><p class=\"doc\">5.2. Ми лишаємо за собою право розкрити вашу персональну інформацію:</p><p class=\"doc\">5.2.1. в тих випадках, в яких цього від нас вимагає закон;</p><p class=\"doc\">5.2.2. у зв’язку з будь-яким поточними або майбутніми судовими процесами;</p><p class=\"doc\">5.2.3. з метою встановлення, реалізації або захисту наших законних прав (включаючи надання інформації іншим сторонам задля запобігання шахрайству);</p><p class=\"doc\">5.2.4. банківським та фінансовим установам, які оперують транзакції ваших покупок наших послуг;</p><p class=\"doc\">5.2.5. будь-якій особі, яка, як ми обґрунтовано вважаємо, може подати запит до суду або іншого уповноваженого органу про розкриття цих персональних даних і, на нашу обґрунтовану думку, цей суд або уповноважений орган може видати розпорядження на розкриття цих персональних даних.</p><p class=\"doc\">5.3. Ми не будемо розкривати вашу персональну інформацію третім особам, за виключенням випадків, зазначених в цих правилах.</p><p class=\"doc\">5.4. Погоджуючись з цими правилами, ви надаєте згоду на передачу вашої персональної інформації, зазначеної в розділі 3.</p><h2 class=\"doc primary--text\">6. Збереження персональної інформації</h2><p class=\"doc\">6.1. Розділ 6 встановлює правила та процедури компанії щодо збереження персональної інформації. Дані правила та процедури призначені для забезпечення виконання нами наших юридичних зобов’язань щодо збереження та видалення персональної інформації.</p><p class=\"doc\">6.2. Персональна інформація, яку ми обробляємо з певною метою або в певних цілях не повинна зберігатися довше, ніж потрібно для досягнення цієї мети або цих цілей.</p><p class=\"doc\">6.3. Без обмежень положень, зазначених в пункті 6.4, ми зазвичай видаляємо персональну інформацію через 30 діб після фактичної відмови користувача сплачувати та користуватися нашими послугами, шляхом несплати подовження дії облікового запису.</p><p class=\"doc\">6.4. Незважаючи на інші положення Розділу 6, ми будемо зберігати документи (включаючи електронні документи), які містять персональну інформацію:</p><p class=\"doc\">6.4.1. в тих випадках, в яких цього від нас вимагає закон;</p><p class=\"doc\">6.4.2. якщо ми вважатимемо, що ці документи можуть мати відношення до будь-якого поточного або майбутнього судового розгляду;</p><p class=\"doc\">6.4.3. з метою встановлення, реалізації або захисту наших законних прав (включаючи надання інформації іншим сторонам задля запобігання шахрайству або зниження кредитних ризиків).</p><h2 class=\"doc primary--text\">7. Захист вашої персональної інформації</h2><p class=\"doc\">7.1. Ми будемо вживати достатні технічні та організаційні заходи для попередження втрати, протиправного використання чи підробки вашої персональної інформації.</p><p class=\"doc\">7.2. Всю надану вами персональну інформацію ми будемо зберігати на орендованих нами захищених (як паролем, так і фаєрволами) серверах.</p><p class=\"doc\">7.3. Всі електронні фінансові транзакції, здійснені за допомогою нашого сайту або додатку, будуть захищені технологією шифрування даних.</p><p class=\"doc\">7.4. Для збереження та отримання користувачем даних на нашому сайті та додатку використовується захищене Інтернет-з’єднання з сервером.</p><p class=\"doc\">7.5. Ви несете повну відповідальність за збереження свого ключа доступу до нашого веб-сайту та додатку, який буде надіслано електронною поштою та збережено у локальному сховищі вашого комп’ютера або пристрою, в таємниці. Ми ніколи не будемо запитувати ваш ключ (за виключенням випадків, коли ви намагаєтесь увійти до свого облікового запису на нашому сайті). Процедура використання ключа при встановленні з’єднання відбувається автоматично.</p><h2 class=\"doc primary--text\">8. Зміни та поправки</h2><p class=\"doc\">8.1. Ми лишаємо за собою право періодично вносити зміни та поправки в ці правила, та публікувати їх нову редакцію на нашому сайті та у оновленнях додатку. Ви повинні періодично перевіряти цю веб-сторінку та розділ у додатку, щоб пересвідчитись, що розумієте зміст змін, внесених до цих правил. Ми також можемо проінформувати вас про внесення змін до цих правил шляхом надсилання електронної пошти або через систему передачі приватних повідомлень нашого сайту.</p><h2 class=\"doc primary--text\">9. Ваші права</h2><p class=\"doc\">9.1. Ви можете надати нам вказівку надавати вам будь-яку персональну інформацію про вас, яку ми маємо; надання такої інформації буде здійснюватися в наступних випадках:</p><p class=\"doc\">9.1.1. для відновлення помилково видаленої або втраченої інформації;</p><p class=\"doc\">9.1.2. відновлення дії втраченого облікового запису, якщо оплата за надання наших послуг не була здійснена вчасно.</p><p class=\"doc\">9.2. Ми лишаємо за собою відмовити в наданні інформації за вашим запитом, в межах чинного законодавства.</p><p class=\"doc\">9.3. Ви маєте право надати нам вказівку не обробляти вашу персональну інформацію в маркетингових цілях шляхом надсилання повідомлення на адресу сервісу підтримки support@tripcount.clickу довільній формі.</p><h2 class=\"doc primary--text\">10. Сторонні веб-сайти</h2><p class=\"doc\">10.1. Наш веб-сайт та додаток містять гіперпосилання на, та деталі про веб-сайти сторонніх компаній та осіб. Ми не маємо інструментів керування, та не несемо відповідальності за політику конфіденційності й практики сторонніх осіб та компаній в цій галузі.</p><h2 class=\"doc primary--text\">11. Оновлення інформації</h2><p class=\"doc\">11.1. Будь-ласка, своєчасно повідомляйте нас, якщо ваша персональна інформація, яка знаходиться у нас, потребує оновлення чи виправлень.</p><h2 class=\"doc primary--text\">12. Файли-Cookies</h2><p class=\"doc\">12.1. Наш веб-сайт та додаток використовують файли-cookies. Cookie – це файл, що містить ідентифікатор (стрічку, яка складається з літер та цифр), і який надсилається веб-сервером до веб-браузеру або додатку на приладі, та зберігається браузером / додатком локально. В подальшому, ідентифікатор надсилається назад на сервер кожного разу, коли браузер або додаток запитує веб-сторінку з серверу. Файли-cookies можуть бути або «постійними» або «сеансові»: постійні будуть зберігатися локально та будуть придатними до завершення терміну дії, якщо тільки не будуть видалені користувачем завчасно; «сеансові» навпаки – будуть видалятися після завершення сеансу роботи з сайтом або після закриття браузеру чи додатка. Файли-cookies зазвичай не містять жодної інформації, яка ідентифікує особу користувача. Проте, ваша персональна інформація, яку ми маємо, може бути пов’язана з інформацією, що зберігається та отримана від файлів-cookies. На нашому веб-сайті ми використовуємо лише постійні файли-cookies для ідентифікації користувача та збереження поточних даних, таких як обрана мова інтерфейсу, поточний активний розділ сайту чи додатку, перелік поточних проектів, до яких надано доступ користувачу та ін.</p><p class=\"doc\">12.2. Більшість браузерів та деякі операційні системи пристроїв надають вам можливість відмовитися від використання файлів-cookies. У разі використання такої можливості, основні функції нашого веб-сайту та додатку будуть недоступні.</p><p class=\"doc\">12.3. Ми не використовуємо файли-cookies, які застосовуються для маркетингового аналізу та цільовій реклами, зокрема  Google Analytics, Adwords та подібні їм.</p><p class=\"doc\"><i>Дата останньої редакції 14.05.2023 р.</i></p>",
      userAgreementUA: "<h2 class=\"doc primary--text\">1. Вступ</h2><p class=\"doc\">Ця Угода Користувача (далі – «Угода») укладається між Користувачем та Розробником, Фізичною особою-підприємцем Кеворкяном Андрієм (далі – «Розробник»), і регулює використання ресурсу Tripcount (далі – «Ресурс») у вигляді мобільного додатку (далі – «Додаток») та браузерного додатку – інтернет-сайту www.tripcount.click (далі – «Сайт»), які є власністю Розробника.</p><h2 class=\"doc primary--text\">1. Загальна частина</h2><p class=\"doc\">1.1. Користуватися Ресурсом дозволено тільки особі – Користувачу, що прийняла усі умови даної Угоди та умови Політики конфіденційності, посилання на які розміщені на головній сторінці сайту за адресою <a href=\"https://www.tripcount.click/privacy/doc\">www.tripcount.click/privacy/doc</a>, на головній сторінці Додатка, а також доступні для завантаження у вигляді файлів pdf із накладеним кваліфікованим електронним підписом Розробника. Перевірити підписи можливо відповідним сервісом Міністерства цифрової трансформації України за адресою <a href=\"https://czo.gov.ua/verify\">czo.gov.ua/verify</a>.</p><p class=\"doc\">1.2. Користувач зобов’язаний ознайомитися з Угодою та умовами Політики конфіденційності перед використанням Ресурсу. При використанні будь-якої частини Ресурсу, Користувач погоджується з умовами даної Угоди та умовами Політики конфіденційності. Якщо Користувач не погоджуєтеся з вказаними умовами, то йому не надається статус Користувача і йому забороняється використовувати Ресурс.</p><p class=\"doc\">1.3. Умови Угоди поширюються на всіх користувачів Ресурсу – як на незареєстрованих користувачів, так і на зареєстрованих, що мають будь-який обліковий запис. Під обліковим записом розуміється сукупність інформації про користувача й даних авторизації.</p><h2 class=\"doc primary--text\">2. Права, обов’язки та відповідальність Користувача та Розробника</h2><p class=\"doc\">2.1. Повний доступ до Ресурсу, зокрема створення проектів суспільної фінансової участі (далі – «Поїздок») та залучення до них інших Користувачів (далі – «Мандрівників»), можливий тільки для зареєстрованого Користувача (що створив обліковий запис та сплатив користування Ресурсом). Незареєстровані Користувачі можуть користуватися Ресурсом у якості мандрівників.</p><p class=\"doc\">2.2. Оплата користування Ресурсом для зареєстрованих Користувачів відбувається шляхом передплати майбутнього періоду користування за тарифним планом. Тарифний план визначає доступні можливості Користувача по використанню Ресурсу, тривалість періоду передплати та вартість користування.</p><p class=\"doc\">2.3. Розробник може надавати пільговий безоплатний період користування новим зареєстрованим користувачам Додатку для детального ознайомлення з його можливостями, якості роботи та прийняття рішення про вибір тарифного плану передплати. </p><p class=\"doc\">2.4. Оплата зареєстрованим Користувачем передплати за тарифним планом означає, що Користувач повністю задоволений можливостями та якістю роботи Ресурсу, готовий сприймати його «як є» і не має таких претензій та зауважень до Розробника, які б могли вплинути на рішення Користувача щодо користування Ресурсом.</p><p class=\"doc\">2.5. Повне чи часткове повернення сплачених коштів Користувачу та тимчасове чи повне припинення їм користуванням Ресурсом не передбачене у разі виконання Розробником своїх обов’язків за цією угодою.</p><p class=\"doc\">2.6. Розробник зобов’язаний не змінювати умови користування Ресурсом у бік обмеження можливостей протягом дії періоду передплати за обраним Користувачем тарифним планом.</p><p class=\"doc\">2.7. Розробник має право змінювати умови користування Ресурсом для зареєстрованих користувачів у бік розширення можливостей у будь-який час. У разі коли такі зміни вимагають додаткових дій від Користувача, Розробник зобов’язаний інформувати про це Користувача електронним листом.</p><p class=\"doc\">2.8. Користувач має право подовжувати передплату за існуючим тарифним планом, якщо такий план пропонується на момент подовження, а також змінювати тарифний план своєї передплати за наступними умовами.</p><p class=\"doc\">2.8.1. Термін, у який доступне подовження або зміна тарифного плану:</p><p class=\"doc\">– у разі подовження користування за існуючим тарифним планом або переходу на тарифний план з рівною або нижчою кількістю дозволених активних Поїздок – протягом останніх 30 днів дії передплати за поточним тарифним планом;</p><p class=\"doc\">– у разі переходу на тарифний план з більшою кількістю дозволених активних Поїздок – у будь-який час.</p><p class=\"doc\">2.8.2 У разі подовження користування за існуючим тарифним планом або переходу на тарифний план з рівною кількістю дозволених активних Поїздок новий термін користування додається до дати закінчення передплати за поточним тарифним планом, незалежно від вартостей поточного та нового тарифних планів. При цьому, якщо умови нового тарифного плану відрізняються від поточних, нові умови починають діяти, починаючи з дати фактичної оплати за новим тарифним планом, навіть при наявності невикористаного залишку.</p><p class=\"doc\">2.8.3. При наявності невикористаного залишку днів користування за поточним тарифним планом у разі переходу на інший тарифний план з іншою кількістю дозволених активних Поїздок відбувається перерахунок такого залишку за фактичною вартістю днів користування. Під фактичною вартістю днів користування мається на увазі відношення фактично сплаченої суми за передплату до терміну її дії у днях.</p><p class=\"doc\">2.8.4. Перехід на тарифний план з нижчою кількістю дозволених активних Поїздок недоступний у разі, якщо фактична кількість активних Поїздок Користувача перевищує дозволену у новому тарифному плані. У такому разі Користувачу необхідно самостійно скоротити кількість активних поїздок.</p><p class=\"doc\">2.9. Обліковий запис зареєстрованого Користувача має прив’язку до приладу з встановленим Додатком або до браузера. Користувач має право без обмежень переносити свій обліковий запис між приладами та браузерами, але одночасно активним може бути лише одна прив’язка, яка зроблена останньою. Пільговий період, зазначений у п. 2.3 Угоди, може бути наданий лише один раз для одного приладу з встановленим Додатком, для чого обліковий запис потрібно зареєструвати саме у цьому Додатку. Для облікового запису, зареєстрованого на Сайті (у браузері) пільговий період не надається.</p><p class=\"doc\">2.10. Розробник має право обмежити доступ Користувача до його даних у разі закінчення терміну передплати або пільгового періоду, якщо Користувач не виконав передплату на наступний період.</p><p class=\"doc\">2.11. Розробник зобов’язується зберігати дані зареєстрованого Користувача у разі закінчення терміну його передплати протягом 30 діб з моменту закінчення сплаченого періоду та відновити доступ до даних у разі поновлення передплати Користувачем, якщо така послуга буде передбачена новим тарифним планом.</p><p class=\"doc\">2.12. Якщо протягом 30 діб після закінчення сплаченого періоду Користувачем не буде поновлено передплату, дані Користувача будуть видалені остаточно.</p><p class=\"doc\">2.13. Розробник зобов’язаний підтримувати серверну частину Ресурсу і забезпечувати її цілодобову доступність. У разі виникнення необхідності проведення профілактичних робіт тривалістю більше 15 хвилин, протягом яких доступ до Ресурсу буде неможливим або обмеженим, розробник зобов’язаний попередити Користувачів щонайменьше за 24 години до початку таких робіт. Профілактичні роботи, якщо вони не термінові, повинні плануватися у період з 22.00 до 6.00 за київським часом. Тривалість таких робіт не повинна перевищувати 6 годин.</p><p class=\"doc\">2.14. У разі виникнення тривалих (більше 6 годин) збоїв у роботі Ресурсу, як планових, так і непередбачених, Розробник зобов’язаний надати компенсацію Користувачу у вигляді додаткового часу дії передплати, рівного подвійному періоду недоступності ресурсу протягом періоду передплати, але не меньше ніж на одну добу.</p><p class=\"doc\">2.15. Користувач зобов’язаний використовувати можливості Ресурсу лише для таких цілей, які не порушують законодавство України та закони тих держав, які відвідують Користувачі. Облік Поїздок із записами витрат, що порушують закон, наприклад «Хабар поліцейському», або «Купівля сигарет для контрабанди» вважається порушенням цієї угоди.</p><p class=\"doc\">2.16. Розробник та Користувач зобов’язані виконувати всі умови щодо конфіденційності та збереження особистих даних, які наведені у «Політиці конфіденційності».</p><p class=\"doc\">2.17. Підтримка користувачів за електронною поштою є опціональною та надається у разі, якщо це передбачене тарифним планом. Адреса технічної підтримки: <a href=\"mailto:support@tripcount.click\">support@tripcount.click</a></p><p class=\"doc\">2.18. Усі зареєстровані Користувачі мають право надсилати зауваження та вносити пропозиції електронними листами на адресу технічної підтримки. Якщо зауваження та пропозиції будуть визнані Розробником, як суттєві та корисні, вони будуть розглянуті, навіть якщо опціональна технічна підтримка не передбачена у тарифному плані Користувача.</p><p class=\"doc\">2.19. Зареєстрований Користувач маює право видалити свій обліковий запис із повним видаленням усіх створених даних у будь-який час за посиланням <a href=\"https://www.tripcount.click/wipe/account\">www.tripcount.click/wipe/account</a>. При цьому повернення Користувачу невикористаного залишку коштів не передбачене.</p><h2 class=\"doc primary--text\">3. Інші умови</h2><p class=\"doc\">3.1. Розробник має право вносити зміни в дану Угоду. Усі внесені до Угоди зміни будуть доступні у вигляді нової редакції Угоди, за поточним посиланням. У випадку внесення до Угоди істотних змін, Розробник додатково повідомить зареєстрованого Користувача про ці зміни по електронній пошті. Усі зміни Угоди набувають чинності з моменту їх публікації. Використовуючи Ресурс, Користувач підтверджує згоду з новими умовами Угоди в редакції, що діє на момент використання Користувачем послуг або Сайту. Попередні редакції Угоди, які втратили дію, доступні Користувачу для завантаження у вигляді pdf файлів із накладеним електронним кваліфікованим підписом Розробника.</p><p class=\"doc\">3.2. Розробник не несе відповідальності за шкоду або збитки, яких зазнав Користувач або треті особи в результаті:</p><p class=\"doc\">– помилкового розуміння або нерозуміння умов даної Угоди, інструкцій або вказівок про порядок використання Ресурсу.</p><p class=\"doc\">– видалення або помилкової редакції даних зареєстрованими Користувачами та/або Мандрівниками.</p><p class=\"doc\">– пошкодження або втрати даних внаслідок технічних проблем на Ресурсі.</p><p class=\"doc\">– обмеження доступу або видалення даних внаслідок несплати Користувачем передплати за користування ресурсом.</p><p class=\"doc\">3.3. Користувач надає Розробнику право надсилати йому повідомлення, що містять інформацію про роботу Ресурса.</p><p class=\"doc\">3.4. У випадку визнання недійсної або нездійсненної будь-якої частини даної Угоди, інші частини Угоди будуть залишатися в чинності. Відмова кожної зі сторін від будь-якого положення або умови даної Угоди, або будь-яке їх порушення не скасовує дію цього положення або умови.</p><p class=\"doc\">3.5. Ресурс надається Розробником «як є». Розробник не гарантує відповідність Ресурсу цілям і очікуванням Користувача, його абсолютно безперебійну й безпомилкову роботу, а також схоронність облікового запису Користувача й інформації, що розміщена Користувачем на Ресурсі. Ресурс використовує шифрування TLS / SSL (протокол https:), що забезпечує безпеку персональних даних, та іншої інформації, яку клієнти вводять та отримують на Ресурсі.</p><p class=\"doc\">3.6. Розробник може в будь-який момент і без повідомлення Користувача поступитися своїми правами за даною Угодою третій стороні.</p><p class=\"doc\">3.7. До даної Угоди й відносинам між Розробником та Користувачем, що виникають у зв’язку з використанням Ресурсу, застосовується законодавство України. Кожна сторона незаперечно погоджується з тим, що відповідні суди України мають виняткову юрисдикцію відносно будь-яких претензій, спорів або розбіжностей, що стосуються Угоди та використання Ресурсу.</p><p class=\"doc\"><i>Дата останньої редакції 14.05.2023 р.</i></p>",
      
      // for payTable
      payTable: [],
      balance: {},
      getMatrix: [-1, 0, 0, 0, 1, 6, 2, 3, 4, 5, 1, 6], // by payment subtype
      matrix: defs.matrix,      
    }
  },
  computed: {
    activeLocales() {
      return structuredClone(this.locales).sort((a, b) => {
        return (a.order < b.order) ? -1 : ( (a.order > b.order) ? 1 : 0 );
      });
    },
    urls() {
      return cordovaApp ? defs.urls.app : ( this.webApp ? defs.urls.web : defs.urls.dev );
    },
    uuid() {    // Свойство this.config.uuid должно существовать при запуске и иметь default значение.
      return cordovaApp ? (shajs("sha1").update(CDDevice.uuid).digest("hex").substring(4,20)) : this.config.uuid;
    },
    userColors() {
      let colors = [];
      for(let idx=1; idx<this.travellers.length; idx++) {
        colors.push(defs.userColors[idx % defs.userColors.length]);
      }
      return colors;
    },   
    snackbarAddPayment: {
      get: function() {
        return this.snackbarAddPaymentAllowed && !this.scrollList; 
      },
      set: function(newVal) {
        this.scrollList = newVal;
      }
    },   
    dialogsNotOpened() {
      return !this.drawer             // hiddeen menu
        && !this.dialogReadonly

        && !this.formCurrencys
        && !this.formTravellers
        && !this.formsPayments    
        && !this.formSetings   
        && !this.formAccount
        && !this.formAdd

        && !this.dialogInfo.model
        && !this.dialogLiqpay.model           // not addPayment+, travellers+, currency+, setup+, readonly+, expandPayment+
        && !this.dialogLiqpayd.model;
    }, 
    snackbarAddPaymentAllowed() {
      return (this.flag & (this.flags.writeMy | this.flags.writeAll))
        && (this.compact > 1) 
        && (this.vfPage > 1)          // payments or statistics
        && (this.vfPage < 4)          // not scanner
        && (this.dataReadonly == 0)   // no api errors
        && (this.travellers.length > 1)
        && !this.apiBusy
        && this.dialogsNotOpened
    },
    transactions() {
      let list = structuredClone(this.transactionsBase);
      list.forEach((item) => {
        item.text = this.$t(item.text);
        item.info = this.$t(item.info);
        item.header = this.$t(item.header);
      }); 
      return list;
    },     
    transactionsRefund() {
      let list = structuredClone(this.transactionsRefundBase);
      list.forEach((item) => {
        item.text = this.$t(item.text);
        item.info = this.$t(item.info);
      });
      return list;
    },
    shareds() {
      let list = structuredClone(this.sharedsBase);
      list.forEach((item)=>{
        item.text =  this.$t(item.text);
      });
      return list;
    },
    lbls() {
      let list = structuredClone(this.lblsBase);
      list.forEach((item)=>{
        item.text =  this.$t(item.text);
        if(item.textAlter) {
          item.textAlter =  this.$t(item.textAlter);
        }
      });
      return list;
    },    
    localeId() {
      return this.locales[this.locale].value;
    },

    // for payTable
    ballanceCurrency() {
      let currency = structuredClone(this.currencys[this.currencys[0].id]);
      currency.id = this.currencys[0].id;
      return currency;
    }
  },
  /*
  updated() {
    document.querySelector('title').innerHTML = "Tripcount Application"; // this.$t("message.appTitle");
  },
  */
  mounted() {
    this.appMounted = true;
    // this.vConsolePurge();
    this.vConsoleTo('Mounted',3);
    if(this.appRefreshed) {
      this.vConsoleTo('Refresh after. Intents deny.',3);
    }
    // this.intentTrigger = true;
    this.appPrepare();
  },
  methods: {
    parseSplit(txt, idx) {
      let parts = txt.split('$');
      if(parts.length < (idx+1)) {
        parts[idx] = '*';
      } 
      return parts[idx];
    },
    setQrTrigger(value) {
      this.qrTrigger = value;
      if(value) {
        this.qrSleepTrigger = true;
        this.qrWekeUpTrigger = false;
      }
    },
    async callApi(method, data, urgent = true, finalCall = true) {
      this.apiBusyTrigger = true;
      window.setTimeout(() => {
        if(this.apiBusyTrigger) {
          this.apiBusy = true;
        }
      }, API_BUSY_DELAY);
      if((method[0] == '_') && !data.uuid) {
        this.vConsoleTo('API call without uuid',3);
        data.uuid = this.uuid;
      }
      return new Promise((resolve, reject) => {
        api(method, data, urgent).then((result) => {
          this.vConsoleTo('API call «'+method+'» resolved: '+JSON.stringify(result),3);
          if(result) {
            this.apiMsg(result);
          }
          resolve(result);
        },() => {
          this.vConsoleTo('API call «'+method+'» rejected',3);
          reject();
        }).finally(() => {
          this.vConsoleTo('API call «'+method+'» complete',3);
          if(finalCall) {
            this.apiBusyTrigger = false;
            this.apiBusy = false;
          }
        });
      });
    },
    cordovaStart() {
      if(!this.cordovaReady) {
        let urlResult = true;
        this.cordovaReady = true;
        this.vConsoleTo('Cordova running. Platform ' + CDCordova.platformId + ' Version ' + CDCordova.version, 3);
        this.dataReadonly = true;      
        this.vConsoleTo('CordovaRdy 2',3);
        // this.cordovaSound = new CDMedia(this.urls.local+'media/t.mp3',() => {},() => {});
        this.cordovaQrSound = new CDMedia(this.urls.local+'media/qr.mp3',() => {},() => {});
        this.cordovaBulSound = new CDMedia(this.urls.local+'media/kap.mp3',() => {},() => {});
        // this.cordovaTsSound = new CDMedia(this.urls.local+'media/tuch.mp3',() => {},() => {});
        window.plugins.intent.getCordovaIntent((Intent) => {  // Передача параметров при запуске приложения
          this.vConsoleTo('Cordova starting Intent '+JSON.stringify(Intent),LOG_INTENT);
          if(!this.appRefreshed) {
            this.vConsoleTo('Cordova starting Intent allowed',LOG_INTENT);
            if(Intent && Intent.data && Intent.data.length) {
              this.vConsoleTo('Starting intent found: '+Intent.data.length, LOG_INTENT);
              this.intentProcess(Intent.data);
              if(this.startingUrlProcessed) {   // URL уже был отработан
                this.tripObserver = false;
                urlResult = this.processUrl();
                if(urlResult) {
                  if(this.masterMode) {
                    this.apiOn();
                  }
                  this.tripObserver = true;
                }
              }
            }
          } else {
            this.vConsoleTo('Cordova starting Intent declined',LOG_INTENT);
          }
          this.appRefreshed = false;
        }, () => {
          this.vConsoleTo('INTENT Error', LOG_INTENT);
        });
        this.vConsoleTo('CordovaRdy 3',3);
        if(!this.cordovaIntentFlag) {
          this.cordovaIntentFlag = true;
          window.plugins.intent.setNewIntentHandler((Intent) => { // Наблюдатель передачи параметров в работающее приложение
            this.vConsoleTo('Cordova Workout intent '+JSON.stringify(Intent),LOG_INTENT);
            if(Intent && Intent.data && Intent.data.length) {
              this.vConsoleTo('Workout intent found: '+Intent.data.length, LOG_INTENT);
              this.intentTrigger = true;
              this.intentProcess(Intent.data);
              this.tripObserver = false;
              urlResult = this.processUrl();
              if(urlResult) {
                if(this.masterMode) {
                  this.apiOn();
                }
                this.tripObserver = true;
              }
            }
          });    
        }
        this.vConsoleTo('CordovaRdy 5',3);
        CDNavigator.app.overrideButton("menubutton",true);
        CDNavigator.app.overrideButton("backbutton",true);
        document.addEventListener("pause", () => { this.cordovaPause(); }, false);      
        document.addEventListener("resume", () => { this.cordovaResume(); }, false);
        document.addEventListener("menubutton", () => { this.cordovaMenu(); }, false);
        document.addEventListener("backbutton", () => { this.cordovaBack(); }, false); 
        window.addEventListener("keyboardDidShow", () => { this.vKeyboard = true; }, false);
        window.addEventListener("keyboardDidHide", () => { this.vKeyboard = false; }, false);
        this.vConsoleTo('Cordova starts',3);
      }
    },
    cordovaBack() {
      this.vConsoleTo('button back',0);
      this.drawer = false;
      this.formSetings = 0;
      this.formAccount = 0;
      this.$refs.childPaymentList.closeForm();
      this.formAdd = false;
      this.formRefund = false;
      this.formTravellers = false;
      this.formCurrencys = false;
      if(cordovaApp) {
        if(this.vfPage == 4) {
          this.showPage(this.config.page);
        }
        this.bull();
      }      
    },
    cordovaMenu() {
      this.vConsoleTo('button menu',0);
      if(this.dialogsNotOpened) {
        this.drawer = true;
      } else {
        this.dialogShowInfo();
      }
      this.bull();
    },
    cordovaResume() {
      if(!this.qrWekeUpTrigger) {      
        this.dataReadonly = true;
        this.vConsoleTo('Wake up',3);
        // window.BackgroundTimer.stop(this.cordovaSuccessCallback, this.cordovaErrorCallback);
        // CDCordova.plugins.backgroundMode.disable();
        setTimeout(() => {
          this.apiOn(false);        
          this.vConsoleTo('Cordova starts after wake up',3);
          this.showPage(this.config.page);
        }, 100);
      } else {
        this.vConsoleTo('Cordova WakeUp by QR scanner',3);
        this.qrWekeUpTrigger = false;   // Не делать исключение повторно
      }
    },
    cordovaVibrate() {
      CDNavigator.vibrate([150, 160, 150]);
    },
    cordovaPause() {
      if(this.qrTrigger && this.qrSleepTrigger) {
        this.vConsoleTo('Cordova Sleep by QR scanner',3);
        this.qrSleepTrigger = false;    // Не делать исключение повторно
        this.qrWekeUpTrigger = true;    // Не обрабатывать ближайший WakeUp
      } else {
        this.showPage(this.config.page);
        this.vConsoleTo('Sleep',3);
        apiSleep();        
      }
    },
    intentProcess(data) {
      if(this.intentTrigger) {
        try {
          const intentUrl = new URL(data);
          this.cordovaUrl = {};
          this.cordovaUrl.key = intentUrl.searchParams.get('k');
          this.cordovaUrl.method = intentUrl.searchParams.get('m');
          this.cordovaUrl.signature = intentUrl.searchParams.get('s');          
          this.vConsoleTo('Intent: '+JSON.stringify(this.cordovaUrl), LOG_INTENT);
          return true;
        } catch (error) {
          this.vConsoleTo('Error intent data '+error.message, LOG_INTENT);
        }
      } else {
        this.vConsoleTo('Intent deny by trigger', LOG_INTENT);
      }
      return false;
    },
    createUuid() {          // уникальный uuid для web app
      let dt = new Date();
      //return 'aaaae95ecbb1ff41';
      this.vConsoleTo('** NEW UUID **', LOG_CONFIG);
      return shajs("sha1").update(dt.getTime().toString() + Math.random()).digest("hex").substring(4,20);
    },
    createCrc(kill = false) {
      let crc = '';
      let names = [];
      for(let elem in this.config) {
        if(elem[0] != '_') {
          names.push(elem);
        } else if(kill) {
          delete(this.config[elem]);
        }
      }
      names.sort().forEach((value, idx) => {
        if(this.config[value]) {
          crc += '@&#x'+idx+'%!{='+this.config[value];
        }
      });
      let target = shajs("sha1").update(crc).digest("hex");
      return {name: '_'+target.substring(4,11), value: target.substring(12,22)};
    },
    async configSave() {
      return new Promise((resolve, reject) => {
        let cryptoCrc = this.createCrc(true);
        this.config[cryptoCrc.name] = cryptoCrc.value;
        if(this.config.currentTrip == 0) {
          this.config.page = 1;
          this.vConsoleTo('=== ALERT!!! TRIP=0 ===',LOG_CONFIG);  
        }      
        if(cordovaApp) {
          this.cordovaSaveConfig(JSON.stringify(this.config)).then(() => {
            this.vConsoleTo('Config saved to APP folder',LOG_CONFIG);
            resolve();
          }, () => { reject(); });
        } else {
          window.localStorage.setItem('config',JSON.stringify(this.config));
          this.vConsoleTo('Config saved to Local storage',LOG_CONFIG);
          resolve();
        }
      });
    },
    async configLoad() {
      let dta = '{}';
      if(cordovaApp) {
        dta = await this.cordovaLoadConfig();
        this.vConsoleTo('Config loaded (app): '+dta, LOG_CONFIG);
      } else {
        dta = window.localStorage.getItem('config');
        this.vConsoleTo('Config loaded (web): '+dta, LOG_CONFIG);
      }
      let result = false;
      if((typeof dta) == 'string') {
        try {
          this.config = JSON.parse(dta);
          this.vConsoleTo('Config parsed', LOG_CONFIG);
          if(this.config.version && 
            (this.config.version == this.configVersion)) { 
            let cryptoCrc = this.createCrc();
            if(this.config[cryptoCrc.name] == cryptoCrc.value) {
              result = true;
              if(!this.config.console) {
                this.vConsoleTo('WEB Console closed by config data', 99);  
              }
              this.vConsoleWebAllow = this.config.console;
              this.vConsoleTo('Config loaded and accepted '+JSON.stringify(this.config), LOG_CONFIG);
            }
          }
        } catch (err) {
          result = false;
        }
      }
      if(!result) {
        this.vConsoleTo('Config default loaded',LOG_CONFIG);
        this.config = defs.config;
        if(!cordovaApp) {
          this.config.uuid = this.createUuid();
          this.vConsoleTo('Default uuid '+this.config.uuid, LOG_CONFIG);
        } else {
          this.defLocale();
        }
        await this.configSave();
      }      
    },
    async cordovaFilesInit() {
      this.vConsoleTo('Config Load 5',LOG_CONFIG);
      return new Promise((resolve, reject) => {
        this.vConsoleTo('Config Load 6',LOG_CONFIG);
        window.requestFileSystem(CDLocalFileSystem.PERSISTENT, 0, (fs) => {
          this.vConsoleTo('File system granted',14);
          fs.root.getFile(CDCordova.file.externalDataDirectory.replace(CDCordova.file.externalRootDirectory, '') + 'config.json',
            { create: true, exclusive: false }, (fileEntry) => {
            this.cordovaFileEntry = fileEntry;
            resolve();
          }, () => {
            this.vConsoleTo('File creation error',14);
            reject(new Error('File creation error'));
          });
        }, () => {
          this.vConsoleTo('File system error',14);
          reject(new Error('File system error'));
        });
      });
    },    
    async cordovaSaveConfig(data) {
      return new Promise((resolve, reject) => {
        this.cordovaFileEntry.createWriter((fileWriter) => {
          fileWriter.onwriteend = () => {
            this.vConsoleTo("Successful file write...",14);
            resolve(data);
          };
          fileWriter.onerror = (e) => {
            this.vConsoleTo("Failed file write: " + e.toString(), 14);
            reject(new Error('Failed file write'));
          };
          if(data) {
            fileWriter.write(data);
          }
        });
      });
    },
    async cordovaLoadConfig() {
      this.vConsoleTo('Config Load 3',LOG_CONFIG);
      return new Promise((resolve, reject) => {
        this.vConsoleTo('Config Load 4',LOG_CONFIG);
        this.cordovaFilesInit().then( () => {
          this.vConsoleTo('Config Load 7',14);
          this.cordovaFileEntry.file((file) => {
            this.vConsoleTo('Config Load 8',14);
            let reader = new FileReader();
            reader.onloadend = () => {
              this.vConsoleTo("Successful file read",14);
              resolve(reader.result);
            };
            reader.readAsText(file);
          }, () => { 
            this.vConsoleTo("Error file reading",14);
            reject(new Error('Bad file'));
          });
        });
      });
    },
    processUrl() {
      let ok = true;      // если false делаем refresh
      let result = true;  // возвращаем true если в планах нет refresh
      this.startingUrlProcessed = true;
      if(this.intentTrigger && !(cordovaApp && this.appRefreshed)) {
        this.intentTrigger = false;
        let url = {};        
        if(cordovaApp) {          // android
          url = this.cordovaUrl;
        } else if(this.webApp) {       // web app
          this.vConsoleTo('process URL (web)', LOG_INTENT);
          if(window.app_intent) {
            this.vConsoleTo('process URL. app_intent: '+JSON.stringify(window.app_intent), LOG_INTENT);
            url.method = window.app_intent.m;
            url.key = window.app_intent.k;
            url.signature = window.app_intent.s;
            window.app_intent = null;
          }
        } else {                  // develope
          let loc = new URL(document.location);
          url.method = loc.searchParams.get('m');
          url.key = loc.searchParams.get('k');
          url.signature = loc.searchParams.get('s');
        }
        // this.vConsoleTo('HTTP URL '+document.location.pathname, LOG_INTENT);
        url.id = parseInt(url.signature);
        url.order = parseInt(url.key);
        if(url.key) {
          this.vConsoleTo('Process URL '+url.method, LOG_INTENT);
          apiUnsubscribe();
          apiSet();
          result = false;
          switch(url.method) {
            case 'webtrial':
              this.vConsoleTo("APP TO WEB CONFIRM", LOG_INTENT);
              this.webTrial();
              break;            
            case 'master':
              this.vConsoleTo("MASTER CONFIRM", LOG_INTENT);
              ok = this.masterConfirm(url.key, url.signature);
              break;
            case 'recover':
              this.vConsoleTo("MASTER RECOVERY", LOG_INTENT);
              ok = this.masterRecover(url.key, url.id);
              break;              
            case 'slave':
              this.vConsoleTo("SLAVE INVITATION", LOG_INTENT);
              this.slaveConfirm(url.key, url.id);
              break;
            case 'justpayd':
              if(url.id) {
                this.vConsoleTo("PAYMENT IN PROCESS", LOG_INTENT);
                this.liqpayProcess();
              } else {
                this.vConsoleTo("PAYMENT COMPLETE. Reboot", LOG_INTENT);
                ok = false;
              }
              break;
            default:
              ok = false;
              break;
          }
          this.vConsoleTo('Process URL complete', LOG_INTENT);
          if(!ok) {
            this.vConsoleTo('Fatal refresh by URL processing', LOG_INTENT);
            this.appRefresh();
          }
        }
      } else {
        this.vConsoleTo('Process URL deny by trigger', LOG_INTENT);
      }
      return result;
    },
    async appStart() {
      this.vConsoleTo('APP Started',3);
      apiLoggerSet(this.vConsoleTo);
      let curTrip = this.config.currentTrip;   
      this.setCurrentTrip(0);
      let pg = parseInt(this.config.page);
      this.showPage((curTrip && pg) ? pg : 1);         
      return new Promise((resolve, reject) => {
        if(this.config.master) {
          this.vConsoleTo('APP Started master mode',3);
          apiSet({id: this.config.master, key: this.config.key, trip: 0, lang: this.locales[this.locale].text}, true);
          apiSet({id: 0, key: '', lang: this.locales[this.locale].text}, false);
          this.loadTrips().then(() => {
            if((curTrip) && (!this.getTripById(curTrip).id)) { // If current trip not alloved
              curTrip = 0;
            }
            this.setCurrentTrip(curTrip);
            this.vConsoleTo('Trips loaded. Current '+this.config.currentTrip,3);
            this.$nextTick(() => {
              this.flagUpdater();
              this.vConsoleTo('Flags updated. Current '+this.flag,3);
              this.$nextTick(() => {
                if(this.processUrl()) {
                  this.vConsoleTo('URL Processed. Master Mode '+this.masterMode,3);
                  if(this.masterMode) {
                    this.apiOn();
                  }
                  this.tripObserver = true;
                  if((this.config.currentTrip == 0) && (this.trips.length)) {
                    this.setCurrentTrip(this.trips[this.trips.length-1].id, true);
                  }
                  this.configSave().then(()=> {
                    this.refreshApiTrigger = false;
                    resolve();
                  },() => {
                    reject();
                  });
                }
              });
            });
          }, () => {});
        } else {
          this.vConsoleTo('APP Started slave mode',3);
          this.refreshTrips().then(() => {
            this.setCurrentTrip(curTrip);
            this.$nextTick(() => {
              this.vConsoleTo('appStart. Tick 1',3);
              this.flagUpdater();
              this.vConsoleTo('Flags updated (slave). Current '+this.flag,3);
              this.$nextTick(() => {
                this.vConsoleTo('appStart. Tick 2',3);
                if(this.processUrl()) {
                  this.vConsoleTo('URL Processed (slave). Master Mode '+this.masterMode,3);
                  if(this.masterMode) {
                    this.apiOn();
                  }
                  this.tripObserver = true;
                  if((this.config.currentTrip == 0) && (this.trips.length)) {
                    this.setCurrentTrip(this.trips[this.trips.length-1].id, true);
                    this.vConsoleTo('New current trip upon load: '+this.config.currentTrip,3);
                    this.configSave().then(()=> {
                      this.refreshApiTrigger = false;
                      resolve();
                    },() => {
                      reject();
                    });
                  }
                }
              });
            });
          });
        }
      });
    },
    vConsolePush(text, channel = 0) {
      this.vConsoleBuffer.push({text: text, channel: channel});
    },
    vConsolePurge() {
      this.webConsoleRdy = true;
      this.vConsoleTo('========= LOG STARTING ========== '+Date(), 99);
      if(this.appMounted && this.vConsoleBuffer.length) {
        this.vConsoleBuffer.forEach( data => {
          this.vConsoleTo(data.text, data.channel);
        });
        this.vConsoleBuffer = [];
        this.vConsoleTo('===PURGED===', 99);
      }
    },
    vConsoleTo(text, channel = 0) {
      if(this.webConsoleRdy) {
        if(this.consoleAllow) {
          console.log(text);
        }      
        if((this.vConsoleChannels == -1) || (this.vConsoleChannels.includes(channel))) {
          let data = {
            channel: channel,
            text: text};
          // '<span style="padding: 0 10px 0 10px; color: white; background-color: '+ this.vConsoleChannelsColor[channel] +'"><b>'+channel+'</b></span> &nbsp;' + text;
          if(this.vConsoleAllow) {
            this.vConsole = this.vConsole + ('<br/>' + data.text);
          }
          if(this.vConsoleWebAllow) {
            apiWebLog(data);
          }
        }
      } else {
        this.vConsolePush(text, channel);
      }
    },
    /*
    paymentsTableProcessing(value) {
      this.paymentsTableProcess = value;
    },
    
    paymentsUpdate(data) {
      this.paymentsTable = structuredClone(data);
    },
    */
    setCurrentTrip(id, force = false) {
      if(force || (this.config.currentTrip != id)) {
        this.vConsoleTo('Current Trip change '+this.config.currentTrip+' >> '+id,3);
        this.config.currentTrip = id;
        this.currentTrip = this.getTripById(id);           
        if(this.tripObserver) {
          if(!id) {
            this.showPage(1, true);
          }
          this.tripDataClean();
          this.flagUpdater();
          this.$nextTick(() => {
            if(this.masterMode) {
              this.apiOn();
            } else {
              apiUnsubscribe();
              apiSet();
            }
          });
        }
      }
    },
    showPageOne() {
      if(webApp && (this.config.page == 1)) {   // Повторный HOME
        window.location.replace(defs.aboutUrl + ((this.locale == 1) ? '' : ('lang/'+this.locales[this.locale].value)));
      } else {
        this.showPage(1, true);
      }
    },
    showPage(page, force = false) {
      this.vConsoleTo('page '+page,3);
      this.drawer = false;
      if(this.config.page != page) {
        this.config.page = (page < 4) ? page : this.vfPage;
        if(force && this.config.currentTrip) {
          this.configSave();
        }
      }
      if(page == 4) {
        this.closeAllDialogs();
        this.setQrTrigger(true);
      }
      this.vfPage = page;
      let idx;
      let elem;
      for(idx=1; idx<5; idx++) {
        elem = document.getElementById('drw-'+idx);
        if(elem) {
          if(idx == page) {
            elem.classList.add('vf-list-active');
          } else {
            elem.classList.remove('vf-list-active');
          }
        }
      }
      return page;
    },
    validationRules() {
      return {
        required: value => !!value || this.$t('message.validation.required'),
        email: value => !!value.match(/^([a-z0-9_\-.])+@([a-z0-9_\-.])+.([a-z0-9])+$/) || this.$t('message.validation.email'),
        number: value => (Math.round(value) > 0) || this.$t('message.validation.numberPos0'),
        numberx: value => (Math.round(value) >= 0) || this.$t('message.validation.numberWith0'),
        length: value => (!value || (value.length == 8)) || this.$t('message.validation.length8'),
      }
    },      
    setLocale(index) {
      if(!this.locales[index].hidden) {
        this.vConsoleTo('New locale: ' + index,3);
        this.config.locale = index;
        this.configSave().then(() => {
          this.vConsoleTo('Locale set refresh',3);
          this.appRefresh();
        });
      }
    },
    appRefresh() {
      this.vConsoleTo('Rebooting APP ...',3);
      let err = 0;
      let tmr;
      apiPing().then((ok) => {
        if(ok) {
          if(this.cordovaApp || this.webApp) {
            window.location.replace(this.urls.rootR);
          } else {
            window.setTimeout(() => {
              window.location.replace(this.urls.rootR);
            }, 5000);
          }
        } else {
          this.vConsoleTo('Offline!', 3);
          err++;
        }
      });
      if(this.cordovaApp) {
        tmr = window.setInterval(() => {
          if(err && (err < 4)) {
            apiPing().then((ok) => {
              if(ok) {
                window.clearInterval(tmr);
                window.location.replace(this.urls.rootR);
              } else {
                this.vConsoleTo('Offline! '+err, 3);
                err++;
              }
            });
          } else {
            window.clearInterval(tmr);
            if(err) {         
              this.modalDialog({
                title: this.$t('message.connectionError'),
                body: '<h3>'+this.$t('message.possibleReason1')+'</h3>',
                close: () => { 
                  this.dialogInfo.model = false;
                  this.appRefresh();
                }
              }); 
            }
          }
        }, 1000);
      }
    },
    appPrepare() {
      this.vConsoleTo('APP refresh 1',3);
      this.dialogInfo.close = this.dialogInfoClose;
      this.configLoad().then( () => {
        apiSetup(this.apiDataProcess, this.apiSetBusy, this.apiStatement, this.apiMsg, this.uuid, this.version);
        //this.vConsoleTo('API setup. UUID: '+this.uuid,3);        
        this.vConsolePurge();
        this.vConsoleTo('APP refresh 2',3);
        if(!(this.locale = this.config.locale)) {
          this.locale = 0;
        }        
        this.$i18n.locale = this.localeId;
        this.$i18n.fallbackLocale = this.localeId;         
        this.$nextTick(() => {
          this.vConsoleTo('APP refresh 3',3);
          this.$forceUpdate();
          this.$nextTick(() => {
            this.vConsoleTo('APP refresh 4',3);
            if(cordovaApp) {
              this.vConsoleTo('APP refresh 5',3);
              this.cordovaStart();
            }    
            this.vConsoleTo('APP refresh 6',3);
            this.appStart().then(() => {
              this.onResize();
              this.tripObserver = true; 
              this.vConsoleTo('APP refresh 7',3);
            },() => {
              this.vConsoleTo('APP refresh Fatal Error',3);
            });
          });
        });
      });
    },
    apiOn(force = true) {
      if(this.currentTrip.id) {
        // this.vConsoleTo('API ON: '+this.slave+' '+this.config.master+' '+this.config.key+' '+this.config.currentTrip);
        if(force) {
          apiSet({id: this.config.master, key: this.config.key, trip: this.config.currentTrip, lang: this.locales[this.locale].text}, true);
          apiSet({id: this.slave, key: (this.slave ? this.currentTrip.key : ''), lang: this.locales[this.locale].text}, false);
          this.apiBusy = true;
        }
        // this.cordovaSoundAllow = false;
        apiSubscribe(force);
      } else {
        apiUnsubscribe(force);
        apiSet();
      }
    },
    bull() {
      if(cordovaApp) {
        this.cordovaBulSound.stop();
        this.cordovaBulSound.play();
      }
    },
    /*
    bell() {  // Сигнал об изменении в платежах
      this.vConsoleTo('Budjet movement found');
      if(cordovaApp && this.cordovaSoundAllow) {
        this.vConsoleTo('Budjet movement play sound');
        this.cordovaSound.stop();
        this.cordovaSound.play();
        this.cordovaVibrate();
      }
      this.cordovaSoundAllow = true;
    },
    */
    apiGetData() {   // Загрузка данных не по подписке
      //this.$refs.childPaymentList.refreshData();
      this.callApi((this.masterMode > 0) ? '_get_data' : 'get_data',{trip: this.currentTrip.id}, true, false).then(result => {
        if(result) {
          this.apiLocker = false;    
          this.apiDataProcess(result);
        } else {
          this.tripDataClean();
          this.apiBusyTrigger = false;
          this.apiBusy = false;
          //this.$refs.childPaymentList.refreshData(2);
        }
      }, () => {
        this.tripDataClean();
        this.apiBusyTrigger = false;
        this.apiBusy = false;
        //this.$refs.childPaymentList.refreshData(2);
      });
    },
    async apiDataProcess(data) {
      // this.vConsoleTo(JSON.stringify(data)); 
      let configNeedUpdate = false;
      // this.$refs.childPaymentList.refreshData();
      if(this.currentTrip.id && (this.currentTrip.id == data.travel)) {
        if(typeof data.closed == 'undefined') {
          if(typeof data.data == 'object') {
            if(this.currentTrip.slave 
              && (data.title != this.currentTrip.name)  // изменено имя поездки
              && (!this.apiLocker || !apiStackDepth('trip_'+this.currentTrip.id))) {  // не идет процесс редакции имени
                let slv = this.config.slaves.find((sl) => {return sl.slave == this.currentTrip.slave;});
                slv.name = data.title;
                configNeedUpdate = true;
            }
            if(data.data.currencys) {
              if(!data.data.currencys[0].id) { // не задана валюта баланса
                data.data.currencys[0].id = 1;
              }
              if(!this.apiLocker || !apiStackDepth('cur_'+this.currentTrip.id)) { // не идет процесс редакции валют
                this.currencys = data.data.currencys;
              }
              if(data.data.travellers) {
                if(!data.data.travellers[0].shema) {  // не заданы имена схем распределения рсходов
                  data.data.travellers[0].shema = ["Main","A","B"];
                }
                if(!data.data.travellers[0].links) { // не заданы привязки схем к видам платежей
                  data.data.travellers[0].links = {};
                }
                if(!this.apiLocker || !apiStackDepth('trv_'+this.currentTrip.id)) {     // не идет процесс редакции участников                     
                  this.travellers = data.data.travellers; 
                  this.travellers.forEach((val, idx) => {
                    if(idx > 0) {
                      if(!this.travellers[idx].shema) { // нет долей в схемах распределения расходов
                        this.travellers[idx].shema = [1,1,1];
                      }
                      if((this.currentTrip.slave) 
                        && (this.currentTrip.slave == val.slave)) {           // этот slave - я
                        let flg = val.allowed ? val.flag : this.flags.read;   // я активен или нет
                        if(this.currentTrip.flag != flg) {                    // изменились мои права доступа
                          this.currentTrip.flag = flg;
                          this.flagUpdater();
                          configNeedUpdate = true;
                        }
                        //this.flag = val.allowed ? this.currentTrip.flag : this.flags.read;  // если участник деактивирован
                      }
                    }
                  });
                }
                if(typeof data.data.payments == 'object') {   // платежи
                  this.payments = data.data.payments;
                  this.payTableCreate();
                  if(this.payments.length) {
                    this.payTableCreate();
                  } else {
                    this.payTable = [];
                    //this.$refs.childPaymentList.refreshData(2);
                  }
                } else {
                  this.tripDataClean();
                  this.vConsoleTo('Invalid payments data',3);
                  //this.$refs.childPaymentList.refreshData(2);
                }
              } else {
                this.tripDataClean();
                this.vConsoleTo('Invalid travellers data',3);
                //this.$refs.childPaymentList.refreshData(2);
              }
            } else {
              this.tripDataClean();
              this.vConsoleTo('Invalid currency data',3);
              //this.$refs.childPaymentList.refreshData(2);
            }
          } else {
            this.tripDataClean();
            this.vConsoleTo('Invalid response data',3);
            //this.$refs.childPaymentList.refreshData(2);
          }
        } else {  // поездка закрыта
          if(this.currentTrip.slave) {
            //this.$refs.childPaymentList.refreshData(2);
            this.modalDialog({
              title: this.$t('message.trips.deleted'),
              body: '<h3>'+this.$t('message.trips.deletedInfo')+'</h3>',
            });
            this.deleteSlave(this.currentTrip.slave);
          } else {
            this.modalDialog({
              title: this.$t('message.trips.deleted'),
              body: '<h3>'+this.$t('message.trips.deletedMasterInfo')+'</h3>',
              close: () => { 
                this.dialogInfo.model = false;
                this.config.page = 1;
                this.configSave();
                this.appRefresh();
              }
            });            
          }
        }
      } else {
        this.tripDataClean();
        this.vConsoleTo('Invalid travel',3);
        //this.$refs.childPaymentList.refreshData(2);
      }
      this.vConsoleTo('Loaded by API',3);
      this.apiLocker = true;
      // this.vConsoleTo('Message or Extra data via Data Load ?',4);
      // this.apiMsg(data);
      if(configNeedUpdate) {
        await this.configSave();
      }   
      this.apiBusyTrigger = false;
      this.apiBusy = false;  
      // this.setCurrentTrip(this.config.currentTrip, true);
    },
    apiMsg(data) {
      if(data.msg) {
        this.vConsoleTo('Message received',4);
        this.msgDialog(data.msg);
      }
      if(data.extra) {
        this.vConsoleTo('Extra data received',4);
        this.extraDataProcess(data.extra);
      }
    },
    apiStatement(statement, memo='') {
      switch(statement) {
        case 1:             // api errors
          this.vConsoleTo('Connection lost',13);
          this.dataReadonly = true;
          this.readonlyAlert();
          break;
        case -3:            // API / server errors
          this.vConsoleTo('Non-critical server error',13);          
          break;
        case -1:            // API / server errors
          this.vConsoleTo('Internal server error - refresh',13);
          this.appRefresh();  
          /*        
          if(!this.dialogInfo.model) {
            this.modalDialog({
              title: this.$t('message.reg.deviceWipeTitle'),
              body: '<h3>'+this.$t(memo)+'</h3>',
              close: () => {
                this.dialogInfo.model = false;
                this.vConsoleTo('API error refresh',13);
                this.appRefresh();
              }
            });
          }
          */
          break;          
        case -2:
          this.vConsoleTo('Wipe by server demand: '+memo,3);
          this.wipe(false);  // Принудительный wipe
          apiWipe();
          this.configSave().then(() => {
            this.modalDialog({
              title: this.$t('message.reg.deviceWipeTitle'),
              body: '<h3>'+this.$t('message.reg.deviceWipe')+'</h3><p>'+memo+'</p>',
              close: () => {
                this.dialogInfo.model = false;
                this.vConsoleTo('WIPE refresh',3);
                this.appRefresh();
              }
            });
           });
          break;
        default:             // no errors
          this.dataReadonly = false;    
          this.readonlyAlert();      
          break;
      }
    },
    getTripBySlave(slave = null) {
      if(!slave) {
        slave = this.currentTrip.slave;
      }
      if(slave) {
        return this.trips.find(trp => trp.slave == slave);
      }
      return {};
    },    
    getTravellerBySlave(slave = null) {
      if(!slave) {
        slave = this.currentTrip.slave;
      }
      if(slave) {
        return this.travellers.find(trv => trv.slave == slave);
      }
      return {};
    },
    getTripById(id, index = false) {
      if(index) {
        return this.trips.findIndex(trip => trip.id == id); 
      } else {
        let trp = this.trips.find(trip => trip.id == id);
        if(typeof trp != 'undefined') {
          return trp;
        } else {
          return {};
        }
      }
    },
    flagUpdater() {
      if(this.currentTrip.id) {
        if(this.currentTrip.slave) {
          this.slave = this.currentTrip.slave;
          let trv = this.getTravellerBySlave();
          if(trv && (typeof trv.allowed != 'undefined')) {
            this.flag = trv.allowed ? this.currentTrip.flag : this.flags.read;
            this.vConsoleTo('Traveller alloved: '+trv.allowed,3);
          } else {
            this.flag = this.currentTrip.flag;
          }
        } else {
          this.slave = 0;
          this.flag = this.flagsUp.creator;        
        }
      } else {
        this.slave = 1;
        this.flag = 0;
      }
      this.masterMode = this.flag ? (this.slave ? -1 : 1) : 0;
    },
    tripDataClean() {
      this.payments = [];
      this.payTable = [];
      this.travellers = defs.travellers;
      this.currencys = defs.currencys;
    },
    // обработчики редакции данных в компонентах
    qrScan(text) {
      if(this.qrTrigger) {
        this.setQrTrigger(false);
        this.vConsoleTo('QR SCAN: '+text,1);
        this.showPage(1);
        this.intentTrigger = true;
        if(this.intentProcess(text)) {
          this.vConsoleTo('Usable QR',1);
          if(cordovaApp) {
            this.vConsoleTo('Usable QR sound',1);
            this.cordovaQrSound.stop();
            this.cordovaQrSound.play();
            this.cordovaVibrate();
          }
          if(this.processUrl()) {
            this.vConsoleTo('Unusable QR processed',1);
            if(this.masterMode) {
              this.apiOn();
            }
          } else {
            this.vConsoleTo('Usable QR processed. Refresh expected.',1);
          }
        } else {
          this.vConsoleTo('Unusable QR',1);
          this.bull();
        }
      }
    },
    addPayment(pay) {
      if(this.masterMode) {
        let payment = {
          type: pay.type,
          subtype: pay.subtype,
          amount: parseFloat((pay.type == 2) ? -pay.amount : pay.amount),
          currency: parseInt(pay.currency),
          rate: parseFloat(pay.rate ? pay.rate : this.currencys[parseInt(pay.currency)].rate),
          payer: parseInt(pay.payer),
          shemaLink: pay.shemaLink,
          shema: (pay.type == 3) ? 3 : parseInt(pay.shema),
          shemas: structuredClone(pay.shemas),
          memo: pay.description,
          icon: pay.icon,
          trip: this.currentTrip.id,
          master: (this.masterMode > 0) ? true : false
        };
        let updateLinks = (this.flag & this.flags.master) ? !this.compareLinks(pay) : false;
        this.vConsoleTo('Payment links need update: '+updateLinks,3);
        if(updateLinks) {
          if(pay.setLink) {
            if(pay.shema == 3) {
              this.travellers[0].links[pay.icon] = structuredClone(pay.shemas);
            } else {
              this.travellers[0].links[pay.icon] = parseInt(pay.shema);
            }
          } else {
            delete(this.travellers[0].links[pay.icon]);
          }
        }
        this.callApi((this.masterMode > 0) ? '_add_payment' : 'add_payment', payment, false).then((result) => {
          if(result) {
            this.vConsoleTo('== Add payment result: '+JSON.stringify(result),3);
            if(updateLinks) {
              this.vConsoleTo('Payment links update',3);
              this.callApi((this.masterMode > 0) ? '_set_travellers' : 'set_travellers', {
                trip: this.currentTrip.id,
                travellers: this.travellers
              }, false).then(() => {
                this.apiGetData();
              });
            } else {    
              this.apiGetData();
            }
          }
        });
      }
    },
    compareLinks(pay) {  // Сравнивает существующие привязки с заданными в платеже. False - требуется фиксация
      let link = this.travellers[0].links[pay.icon];
      let result = true;
      if(pay.setLink || link) {
        if(pay.setLink && link) {         // оба заданы
          if(typeof pay.setLink == 'object') {
            result = (JSON.stringify(link) == JSON.stringify(pay.shemas)) ? true : false;
          } else {
            result = (link == pay.shema) ? true : false;
          }
        } else {    // задан лишь один
          result = false;
        }
      }
      return result;
    },
    deletePayment(idx) {
      this.vConsoleTo('Payment delete '+idx,3);
      this.callApi((this.masterMode > 0) ? '_del_payment' : 'del_payment',{
          trip: this.currentTrip.id,
          index: this.payments[idx].index,
          payer: this.payments[idx].payer
        }).then((result) => {       
          if(result) {
            this.apiGetData();
          }
        });
    },
    payEditSave(idx) {
      if(this.masterMode) {
        this.vConsoleTo('Payment change '+idx,3);
        let pay = structuredClone(this.payments[idx]);
        pay.trip = this.currentTrip.id;
        if(pay.uuid) {
          delete(pay.uuid);
        }
        this.callApi((this.masterMode > 0) ? '_alt_payment' : 'alt_payment', pay).then((result) => {       
          if(result) {
            this.apiGetData();
          }
        });
      }
    },
    travellerAdd(data) {
      this.callApi((this.masterMode > 0) ? '_add_slave' : 'add_slave',{trip: this.currentTrip.id, rules: data}, false).then((result) => {
        if(result) {
          this.apiGetData();
        }
      });
    },
    travellerDel(slave) {
      this.callApi((this.masterMode > 0) ? '_del_slave' : 'del_slave',{trip: this.currentTrip.id, slave: slave}, false).then((result) => {
        if(result) {
          this.apiGetData();
        }
      });
    },    
    travellersSave() {
      if(this.masterMode) {
        apiPush({
          method: (this.masterMode > 0) ? '_set_travellers' : 'set_travellers',
          trip: this.currentTrip.id,
          travellers: structuredClone(this.travellers)
        },'trv_'+this.currentTrip.id);
      }
    },
    slaveInvite(traveller) {
      this.callApi('_invite',{slave:traveller.slave}).then((result) => {
        if(result) {
          let url = this.urls.invite + '&k=' + result.key + '&s=' + result.id;
          this.modalDialog(this.cordovaApp ? {
            title: this.$t('message.trips.invite'),
            okIcon: 'mdi-share-variant-outline',
            okTitle: this.$t('message.trips.inviteAccept'),
            body: `<div style="width: 100%; text-align: center">
              <img style="width: 100%; margin: 20px auto 20px auto" src="` + result.qr + `"/></div>
              <br/>`+'<h3>'+this.$t('message.trips.inviteInfoC')+'</h3>',
            ok: ()=>{
              let shareOptions = {
                message: this.$t('message.trips.inviteAcceptInfo1'),
                subject: 'Tripcount :: '+this.$t('message.trips.inviteAccept'), // For email
                files: [this.urls.logo],
                url: url,
                chooserTitle: this.$t('message.trips.invite')
              };
              window.plugins.socialsharing.shareWithOptions(shareOptions,()=>{
                this.vConsoleTo('Social Sharing complete',1);
              },()=>{
                this.vConsoleTo('Social Sharing error',1);
              });
              // window.plugins.socialsharing.share(this.$t('message.trips.inviteAcceptInfo1'), 'Trip invitation', this.urls.logo, url);
              this.dialogInfo.model = false;
            }
          } : {
            title: this.$t('message.trips.invite'),
            body: `<div style="width: 100%; text-align: center">
              <img style="width: 100%; margin: 20px auto 20px auto" src="` + result.qr + `"/></div>
              <input style="width: 100%; color: white; background-color: white" type="text" id="url-text" value="`+url+`"/>
              <br/>`+'<h3>'+this.$t('message.trips.inviteInfo')+'</h3>',
            open: () => {
              const input = document.getElementById('url-text');
              input.focus();
              input.select();
              document.execCommand('copy');  
              input.blur(); 
            }
          });
        }
      });      
    }, 
    OLDslaveInvite(traveller) {
      this.callApi('_invite',{slave:traveller.slave}).then((result) => {
        if(result) {
          let url = this.urls.invite + '&k=' + result.key + '&s=' + result.id;
          this.dialogInfo.title = this.$t('message.trips.invite');
          this.dialogInfo.close = this.dialogInfoClose;  
          if(this.cordovaApp) {
            this.dialogInfo.body = `<div style="width: 100%; text-align: center">
            <img style="width: 70%; margin: 20px auto 20px auto" src="` + result.qr + `"/>
            </div>
            <br/>`+'<h3>'+this.$t('message.trips.inviteInfoC')+'</h3>';
            this.dialogInfo.ok = () => {
              window.plugins.socialsharing.share(this.$t('message.trips.inviteAcceptInfo1'), 'Trip invitation', this.urls.logo, url);
              this.dialogInfo.ok = null;
              this.dialogInfo.okIcon = null;
              this.dialogInfo.model = false;
            };
            this.dialogInfo.okIcon = 'mdi-share-variant-outline';
            this.dialogInfo.okTitle = this.$t('message.trips.inviteAccept');
          } else {
            this.dialogInfo.body = `<div style="width: 100%; text-align: center">
            <img style="width: 70%; margin: 20px auto 20px auto" src="` + result.qr + `"/>
            </div>
            <input style="width: 100%; color: white; background-color: white" type="text" id="url-text" value="`+url+`"/>
            <br/>`+'<h3>'+this.$t('message.trips.inviteInfo')+'</h3>';
            this.dialogInfo.ok = null;                   
            window.setTimeout(() => {
              const input = document.getElementById('url-text');
              input.focus();
              input.select();
              document.execCommand('copy');  
              input.blur();        
            }, 550);            
          }
          this.dialogInfo.model = true;
        }
      });      
    }, 
    currencySave() {
      if(this.masterMode) {
        apiPush({
          method: (this.masterMode > 0) ? '_set_currencys' : 'set_currencys',
          trip: this.currentTrip.id,
          currencys: structuredClone(this.currencys)
        },'cur_'+this.currentTrip.id);
      }
    },    
    slaveConfirmEvent(event) {
      this.slaveConfirm(event.key, event.slave);
    },
    slaveConfirm(key, slave) {
      this.invitation = {
        slave: parseInt(slave),
        key: key
      };
      apiSet({id: slave, key: key, lang: this.locales[this.locale].text}, false);
      this.callApi('invited',{}).then((result) => {
        if(result) {
          if(this.config.slaves.length >= this.config.maxSlaves) {    // Уже перебор слейвов
            this.modalDialog({
              title: this.$t('message.trips.inviteAccept'),
              body: '<h3>'+this.$t('message.trips.inviteAcceptDeny2')+'</h3>',
              close: () => {
                this.dialogInfo.model = false;
                this.vConsoleTo('Invitation over quota',1);
                this.appRefresh();
              }
            });            
          } else if(this.getTripById(result.id, true) != -1) {      // Уже есть такой
            this.modalDialog({
              title: this.$t('message.trips.inviteAccept'),
              body: '<h3>'+this.$t('message.trips.inviteAcceptInfo1')+'<br/>«<span style="trip-name">'+result.trip+'</span>».<br/>'+this.$t('message.trips.inviteAcceptDeny')+'</h3>',
              close: () => {
                this.dialogInfo.model = false;
                this.vConsoleTo('Invitation no need. Trip exists',1);
                this.appRefresh();
              }
            });
          } else {                                      // Принять / отклонить?
            this.modalDialog({
              title: this.$t('message.trips.inviteAccept'),
              body: '<h3>'+this.$t('message.trips.inviteAcceptInfo1')+'<br/>«<span style="trip-name">'+result.trip+'</span>»<br/>'+this.$t('message.trips.inviteAcceptInfo2')+'<br/>«'+result.name+'».<br/>'+this.$t('message.trips.inviteAcceptInfo3')+'</h3>',
              okTitle: this.$t('message.accept'),
              closeTitle: this.$t('message.cancel'),
              close: () => {
                this.dialogInfo.model = false;
                this.vConsoleTo('Invitation declined',1);
                this.appRefresh();
              },
              ok: () => {
                this.invitation.id = parseInt(result.id);
                this.invitation.flag = parseInt(result.flag);
                this.invitation.name = result.trip;                
                this.config.slaves.push(this.invitation);
                this.setCurrentTrip(this.invitation.id);
                this.vConsoleTo('Invitation accepted',1);
                this.$nextTick(() => {
                  this.config.page = 2;
                  this.configSave().then(() => {
                    this.callApi('invite_accepted',{}).then(() => {
                      this.vConsoleTo('Invite accept refresh',1);
                      this.appRefresh();
                    });
                  }, () => {
                    this.vConsoleTo('Invite accept configSave() error refresh',1);
                    this.appRefresh();    // configSave() error
                  });
                });
              }
            });
          }
        } else {
          this.vConsoleTo('Invite accept result error refresh',1);
          this.appRefresh();    // invited result error  
        }
      }, () => {
        this.vConsoleTo('Invite accept error refresh',1);
        this.appRefresh();    // invited error
      });
    },
    webTrial() {
      this.vConsoleTo("Trying app to web Master confirm", 1);
      this.modalDialog({
        title: this.$t('message.reg.webTrialTitle'),
        body: '<p>'+this.$t('message.reg.webTrial')+
          '</p><ul><li>'+this.$t('message.reg.webTrial1')+
          '</li><li>'+this.$t('message.reg.webTrial2')+
          '</li><li>'+this.$t('message.reg.webTrial3')+'</li></ul>',
        close: () => {
          this.dialogInfo.model = false;
          this.vConsoleTo('webTrial refresh',1);
          this.appRefresh();
        }
      });
    },
    masterConfirm(key,sig) {
      let ok = false;
      if((!this.config.master && this.config.tmpMaster) && 
      ((this.cordovaApp && !this.config.tmpWeb) ||
      (!this.cordovaApp && this.config.tmpWeb))){
        this.vConsoleTo('Master confirfmation',1);
        ok = true;
        apiSet({id: this.config.tmpMaster, key: key, trip: 1, lang: this.locales[this.locale].text}, true);
        this.callApi('_confirm_user',{key: sig, web: this.cordovaApp ? false : true}).then((result) => {
          this.vConsoleTo('Master confirfmation API sent',1);
          if(result) {
            this.vConsoleTo('Master confirfmation API: '+JSON.stringify(result),1);
            this.config.master = this.config.tmpMaster;
            let trial = this.config.tmpTrial;
            delete(this.config.tmpMaster);
            delete(this.config.tmpTrial);
            delete(this.config.tmpWeb);
            this.config.key = key;
            this.config.maxMasters = result.max_masters;
            this.config.maxSlaves = result.max_slaves;            
            this.configSave().then(() => {
              this.vConsoleTo("Master confirmed", 1);
              this.vConsoleTo(JSON.stringify(this.config), 1);  
              this.modalDialog({           
                title: this.$t('message.reg.title'),
                body: '<h3>'+this.$t('message.reg.confirmationOk') + '<br/>' + (trial ? this.$t('message.reg.confirmationTrial') : this.$t('message.reg.confirmationNoTrial')) + '</h3>',
                close: () => {
                  this.dialogInfo.model = false;
                  this.vConsoleTo("Master confirmation refresh", 1);
                  this.appRefresh();
                }
              });
            },() => {
              this.vConsoleTo("Master confirmation - configSave() error", 1);
              this.appRefresh();    // configSave() error
            });
          } else {
            this.vConsoleTo("Master confirmation - _confirm_user result error", 1);
            this.appRefresh();      // _confirm_user result error
          }
        },() => {
          this.vConsoleTo("Master confirmation - _confirm_user error", 1);
          this.appRefresh();    // _confirm_user error
        });
      } else {
        this.vConsoleTo("Unexpected master confirmation", 1);
        this.modalDialog({
          title: this.$t('message.reg.title'),
          body: '<h3>'+this.$t('message.reg.unexpected')+'</h3>',
          close: () => {
            this.dialogInfo.model = false;
            this.vConsoleTo("Master Unexpected confirmation refresh", 1);
            this.appRefresh();
          }
        });
        ok = true;  
      }
      return ok;
    },
    masterRecover(key,id) {
      let ok = false;
      if((!this.config.master) 
        && (id == this.config.tmpMaster)) {
        ok = true;
        apiSet({id: this.config.tmpMaster, key: key, trip: 1, lang: this.locales[this.locale].text}, true);
        this.callApi('_confirm_recovery',{uuid: this.uuid}).then((result) => {
          this.vConsoleTo('Master recovery confirfmation API sent',1);
          if(result) {
            this.config.master = this.config.tmpMaster;
            delete(this.config.tmpMaster);
            this.config.key = key;
            this.configSave().then(() => {
              this.vConsoleTo("Master recovered", 1);
              this.vConsoleTo(JSON.stringify(this.config), 1);
              this.modalDialog({
                title: this.$t('message.reg.titleRecovery'),
                body: '<h3>'+this.$t('message.reg.recoveryOk')+'</h3>',
                close: () => {
                  this.dialogInfo.model = false;
                  this.vConsoleTo("Master recovering refresh", 1);
                  this.appRefresh();
                }
              });
            },() => {
              this.vConsoleTo("Master recovering - configSave() error", 1);
              this.appRefresh();    // configSave() error
            });
          } else {
            this.vConsoleTo("Master recovering confirmation - _confirm_recovery result error", 1);
            this.appRefresh();      // _confirm_recovery result error            
          }
        },() => {
          this.vConsoleTo("Master recovering confirmation - _confirm_recovery error", 1);
          this.appRefresh();    // _confirm_recovery error
        });
      } else {
        this.vConsoleTo("Unexpected master recovering", 1);
        this.modalDialog({
          title: this.$t('message.reg.title'),
          body: '<h3>'+this.$t('message.reg.unexpected')+'</h3>',
          close: () => {
            this.dialogInfo.model = false;
            this.vConsoleTo("Master Unexpected recovering refresh", 1);
            this.appRefresh();
          }
        });
        ok = true;               
      }
      return ok;
    },    
    masterRegister(data) {
      this.config.master = 0;
      if(!this.config.master && data.email) {
        apiWipe(false);
        this.config.email = data.email;
        if(!cordovaApp) {
          this.config.uuid = this.createUuid();
        }
        this.configSave().then(() => {
          this.vConsoleTo("Current uuid: "+this.config.uuid+' / '+this.uuid, 1);
          this.callApi('_add_user',{uuid: this.uuid, email: this.config.email, recover: data.recover, lang: this.locales[this.locale].text, web: this.cordovaApp ? 0 : 1}).then((result) => {
            if(result) {
              this.config.tmpMaster = result.id;
              if(!data.recover) {
                this.config.tmpTrial = result.trial ? 1 : 0;
                this.config.tmpWeb = result.web ? 1 : 0;
              }
              this.config.maxMasters = result.max_masters;
              this.config.maxSlaves = result.max_slaves;  
              if(!result.key) {
                this.modalDialog({      
                  title: this.$t('message.reg.title'),
                  body: '<h3>'+this.$t('message.reg.confirmation')+
                    (data.recover ? '' : ('<br/>'+
                    this.$t('message.reg.confirmation'+(result.trial ? 'A' : (this.cordovaApp ? 'C' : 'B')))))+'</h3>'
                });
              }
              this.configSave().then(() => {
                this.vConsoleTo("WAITING for confirm", 1);
                this.vConsoleTo(JSON.stringify(this.config), 1);
                if(data.recover && result.key) {        // wildcard for google play stuff
                  this.masterRecover(result.key,result.id);
                }
              });
            } else {
              this.vConsoleTo('Master recovery / register error',1);
              this.modalDialog({
                title: this.$t(data.recover ? 'message.reg.titleRecovery' : 'message.reg.title'),
                body: '<h3>'+this.$t(data.recover ? 'message.reg.recoveryBad' : 'message.reg.regBad')+'</h3>',
                close: () => {
                  this.dialogInfo.model = false;
                  this.vConsoleTo('Master recovery / register error refresh',1);
                  this.appRefresh();
                }
              });
            }
          });
        });
      }
      this.formAccount = 0;
    },
    googlePlayDialog(result, product_id) {
      const {store, Platform} = window; // CDPurchase;
      const product = store.get(product_id, Platform.GOOGLE_PLAY);
      const transaction = store.findInLocalReceipts(product);
      this.vConsoleTo('Google Play Product «'+product_id+'» data: '+JSON.stringify(product),21);
      this.vConsoleTo('Google Play Transaction data: '+JSON.stringify(transaction),21);
      this.modalDialog({
        title: this.$t('message.reg.liqpayTitle'),
        body: `<div style="text-align:center">
            <img style="width:50%" src="${this.urls.logoGP}"/>
          </div>
          <h3>${this.$t('message.reg.GpayInfo')}</h3>
          <table class="table">
            <tr>
            <th class="table-r">${this.$t('message.reg.order')}</th>
            <th class="table-l">${result.order}</th>
            </tr>
            <tr>
            <th class="table-r">${this.$t('message.reg.amount')}</th>
            <th class="table-l">${result.amount+' '+result.currency}</th>
            </tr>                                                 
          </table>`,
        okTitle: this.$t('message.reg.pay'),
        closeTitle: this.$t('message.cancel'),
        ok: () => {       // product.canPurchase ? 
          this.dialogInfo.model = false;
          product.getOffer().order();
        }
      });
    },
    revenueCatInit() {    // Google play Payment provider
      if(!this.revenueCat) {
        this.revenueCat = CDPurchases;
        this.revenueCat.setLogLevel(this.revenueCat.LOG_LEVEL.DEBUG);
        this.revenueCat.configureWith({
          apiKey : defs.billing.revenueKey,
          appUserID : 'user_'+this.config.master
        });
        this.vConsoleTo('RevenueCat configured',21);
      }      
    },
    liqpayStart(tarif) {
      const {store, ProductType, Platform, LogLevel} = window; // CDPurchase;
      this.vConsoleTo('Payment start.', 21);
      this.callApi('_pay_prepare',{tarif: tarif.id, lang: this.locales[this.locale].liqpay, google: this.cordovaApp, price: this.revenueCatPacks[tarif.id]}).then((result) => {
          if(result) {
            this.vConsoleTo('Payment prepared.', 21);
            let product_id = result.product;
            switch(result.vendor) {
              case 1:    // liqpay
                this.vConsoleTo('Liqpay payment start.', 21);
                this.dialogLiqpay.data = result;
                this.config.order = this.dialogLiqpay.data.order;
                this.configSave();
                this.dialogLiqpay.model = true;
                break;
              case 0:   // RevenueCat
                this.vConsoleTo('RevenueCat payment start. Product '+product_id+' for '+this.config.master, 21);
                this.revenueCatInit();
                this.revenueCat.purchaseProduct(product_id, ({ productIdentifier, customerInfo }) => {
                    this.vConsoleTo('RevenueCat Processed '+productIdentifier, 21);
                    this.vConsoleTo(JSON.stringify(customerInfo), 21);
                    this.callApi('_pay_complete',{order: result.order, status: PAYMENT_STATUS_PAYD, payment: customerInfo.nonSubscriptionTransactions[0]}).then(() => {
                      this.modalDialog({
                        title: this.$t('message.reg.liqpayTitle'),
                        body: this.$t('message.reg.complete'),
                        close: () => {
                          this.dialogInfo.model = false;
                          this.appRefresh();
                        }
                      });
                    });                    
                  }, ({error, userCancelled}) => {
                    this.vConsoleTo('RevenueCat Error.', 21);
                    this.vConsoleTo(JSON.stringify(error), 21);
                    let statement;
                    let msgBody;
                    if(error.code) {
                      switch(error.code) {
                        case 20:	// Pending
                          this.vConsoleTo('Pending.', 21);
                          statement = PAYMENT_STATUS_PENDING;
                          msgBody = 'message.reg.pending';
                          break;
                        case 3:	// Deny
                          this.vConsoleTo('Deny.', 21);
                          statement = PAYMENT_STATUS_FAULT;
                          msgBody = 'message.reg.dispose';
                          break;
                        case 1:	// Cancel
                          this.vConsoleTo('Canceled. '+userCancelled, 21);
                          statement = PAYMENT_STATUS_FAULT;
                          msgBody = 'message.reg.payCanceled';                          
                          break;
                        default:
                          this.vConsoleTo('Unknown reason '+error.code);
                          statement = PAYMENT_STATUS_UNKNOWN;
                          msgBody = 'message.reg.dispose';                       
                          break;
                      }
                      this.callApi('_pay_complete',{order: result.order, status: statement, payment: {error: this.$t(msgBody)}}).then(() => {
                        this.modalDialog({
                          title: this.$t('message.reg.liqpayTitle'),
                          body: this.$t(msgBody),
                          close: () => {
                            this.dialogInfo.model = false;
                            this.appRefresh();
                          }
                        });
                      });                       
                    }
                  }, null, this.revenueCat.PURCHASE_TYPE.INAPP);
                break;
              case 3:   // iaptic
                if(this.cordovaApp)
                {
                  this.vConsoleTo('Google Play payment start. Product '+product_id, 21);
                  this.vConsoleTo('App '+defs.billing.appName, 21);
                  this.vConsoleTo('Key '+defs.billing.apiKey, 21);
                  const iaptic = new CDPurchase.Iaptic({
                    url: 'https://validator.iaptic.com',
                    appName: defs.billing.appName,
                    apiKey: defs.billing.apiKey
                  });
                  store.validator = iaptic.validator;
                  store.verbosity = LogLevel.DEBUG;
                  store.error((error) => {
                    this.vConsoleTo('Google Play Purchase Error: ' + error.message, 21);
                  });
                  store.when(product_id).productUpdated(() => {
                    this.vConsoleTo('Google Play Product updated', 21);
                    this.googlePlayDialog(result, product_id)
                  }).approved((transaction) => {
                    this.vConsoleTo('Google Play Product approved: '+JSON.stringify(transaction), 21);
                    this.callApi('_gpay_complete',{order: result.order}).then(() => {
                      this.modalDialog({
                        title: this.$t('message.reg.liqpayTitle'),
                        body: 'Finished',
                        close: () => {
                          this.dialogInfo.model = false;
                          this.appRefresh();
                        }
                      });
                    });
                    transaction.verify();
                    transaction.finish();
                  }).verified((receipt) => {
                    this.vConsoleTo('Google Playment verified', 21);
                    receipt.finish();
                  }).unverified(() => {
                    this.vConsoleTo('Google Playment cannot be verified', 21);
                  });
                  this.vConsoleTo('Google Play watchers Ok', 21);  
                  store.register([{
                    type:  ProductType.CONSUMABLE,
                    id:    product_id,
                    platform: Platform.GOOGLE_PLAY                    
                  }]);
                  this.vConsoleTo('Google Play Product registred', 21);
                  store.initialize(Platform.GOOGLE_PLAY);
                  this.vConsoleTo('Google Play payment initialized '+Platform.GOOGLE_PLAY, 21);
                  this.googlePlayDialog(result, product_id);
                }
                break;
            }
          }
      });
    },
    emailSave(email) {
      this.callApi('_alt_user',{email: email}).then((rslt) => {
        if(rslt) {
          this.config.email = email;
          this.configSave();
        }
      });
    },
    NoNeedliqpayBrowser(id) {
      CDCordova.InAppBrowser.open(this.urls.liqpayBrowser + id,'_system');
    },
    liqpayPay() {
      document.getElementById('liqpay-form').submit();
      this.dialogLiqpay.model = false;
    },
    liqpayProcess() {
      if(this.config.order) {
        this.dialogLiqpayd = {
          model: true,
          title: 'Payment in process',
          order: this.config.order,
          counter: 10,
          status: 0        
        };
        let timer = window.setInterval(() => {
          if(--this.dialogLiqpayd.counter) {
            this.callApi('_liqpay_info', {id: this.config.order}).then((result) => {
              if(result && result.status) {
                window.clearInterval(timer); 
                this.config.order = 0;
                this.configSave().then(() => {
                  this.dialogLiqpayd.counter = 0;
                  this.dialogLiqpayd.status = 2;
                });                             
              }
            });
          } else {
            this.dialogLiqpayd.status = 1;
            window.clearInterval(timer);
          }
        }, 2000);
      }
    },
    async refreshTrips(save = false) {
      return new Promise((resolve, reject) => {
        this.vConsoleTo('Refresh trips starts',3);
        this.trips = [];
        if(this.config.master) {
          this.config.masters.forEach(trip => {
            let trp = structuredClone(trip);
            trp.flag = this.flagsUp.creator;
            this.trips.push(trp);
          });
        }
        this.vConsoleTo('Refresh trips process',3);
        this.config.slaves.forEach((slave) => {
          if(this.getTripById(slave.id, true) == -1) {
            this.trips.push(slave);
          } 
        });
        if(!this.trips.length) {
          this.showPage(1);
        }
        if(save) {
          this.configSave().then(() => { 
            this.vConsoleTo('Trips refreshed and saved',3);
            resolve();
          }, () => { 
            reject();
          });
        } else {
          this.vConsoleTo('Trips refreshed',3);
          resolve();
        }        
      });        
    },
    async loadTrips(save = false) {
      return new Promise((resolve, reject) => {
        this.vConsoleTo('Load trips',3);
        if(this.config.master) {
          this.callApi('_get_trips',{uuid: this.uuid}).then((result) => {
            this.config.masters = [];
            if(result) { 
              this.config.maxMasters = result.maxMasters;
              this.config.maxSlaves = result.maxSlaves;
              this.config.xls = result.xls;            
              if(result.trips) {
                this.vConsoleTo('Trips loaded',3);
                result.trips.forEach(trip => {
                  this.config.masters.push(trip);
                });
              }
              // this.vConsoleTo('Message or Extra data via Trips Load?');
              // this.apiMsg(result);
              this.refreshTrips(save).then(() => {
                resolve(true);
              }, () => { reject();});
              //}
            } else {
              reject();
              //resolve(true);
            }
          });
        } else {
          resolve(null);
        }
      });
    },
    extraDataProcess(data) {
      for(let key in data) {
        this.vConsoleTo('Extra data received: ' + JSON.stringify(data), LOG_EXTRA_DATA);
        switch(key) {
          case 'logChannels':
            if(typeof data.log_remote == 'object') {
              this.vConsoleChannels = structuredClone(data.log_remote);
            } else if(data.log_remote == -1) {
              this.vConsoleChannels = -1; // все каналы
            } else {
              this.vConsoleChannels = []; // все отключить  this.vConsoleWebAllow
            }
            break;
          case 'logRemote':
            this.vConsoleWebAllow = !!data.logRemote;
            break;
          case 'logRemoteFix':
            this.vConsoleWebAllow = !!data.logRemoteFix;
            this.config.console = this.vConsoleWebAllow;
            this.configSave().then(() => {
              this.modalDialog({
                title: 'Remote log',
                body: '<h3>'+'Remote Log '+(this.vConsoleWebAllow ? 'on' : 'off')+'</h3>',
                close: () => {
                  this.dialogInfo.model = false;
                  this.vConsoleTo('Remote Log switch refresh',4);
                  this.appRefresh();
                }
              });
            });            
            break;            
          case 'refresh':
            this.vConsoleTo('API extra data refresh',4);
            this.appRefresh();     
            break;       
          case 'wipe':
            this.wipe(false);
            apiWipe();
            this.configSave().then(() => {
              this.modalDialog({
                title: this.$t('message.reg.deviceWipeTitle'),
                body: '<h3>'+this.$t('message.reg.deviceWipe')+'</h3>',
                close: () => {
                  this.dialogInfo.model = false;
                  this.vConsoleTo('Remote WIPE refresh',4);
                  this.appRefresh();
                }
              });
            });
            break;
        }
      }
    },
    msgDialogConfirm(id, reboot = false) {
      this.callApi((this.masterMode < 0) ? 'msg_confirm' : '_msg_confirm', {id: id, master: this.config.master}).then(() => {
        this.dialogInfo.ok = null;
        this.dialogInfo.model = false;
        if(reboot) {
          this.appRefresh();
        }
      });
    },
    msgDialog(msg) {
      this.dialogInfo.title = msg.title;
      this.dialogInfo.body = msg.body;
      this.modalDialog({
        title: msg.title,
        body: msg.body,
        okTitle: msg.link ? this.$t('message.open') : ((msg.flag & MSG_FLAG_CONFIRM) ? 'Ok' : null),
        ok: msg.link ? (() => {
          if(this.cordovaApp) {
            CDCordova.InAppBrowser.open(msg.link,'_system');          
          } else {
            window.open(msg.link,'_blank');
          }
          this.dialogInfo.model = false;
          if(!(msg.flag & MSG_FLAG_NOCONFIRM)) {   // отправить явное уведомление о посещении ссылки. Возможно, с перезагрузкой
            this.msgDialogConfirm(msg.id, (msg.flag & MSG_FLAG_REFRESH));
          }
        }) : ((msg.flag & MSG_FLAG_CONFIRM) ? () => {   // отправить явное уведомление о согласии. Возможно, с перезагрузкой
            this.msgDialogConfirm(msg.id, (msg.flag & MSG_FLAG_REFRESH));
        } : null),
        close: () => {
          if(msg.flag & MSG_FLAG_CONFIRM) {
            this.dialogInfo.ok = null;
            this.dialogInfo.model = false;
          } else {
            if(!(msg.flag & MSG_FLAG_NOCONFIRM)) {      // отправить уведомление о прочтении. Возможно, с перезагрузкой
              this.msgDialogConfirm(msg.id, (msg.flag & MSG_FLAG_REFRESH));
            } else if(msg.flag & MSG_FLAG_REFRESH) {    // перезагрузка
              this.dialogInfo.model = false;
              this.appRefresh();
            } else {                                    // просто закрыть, уведомление не нужно
              this.dialogInfo.ok = null;          
              this.dialogInfo.model = false;              
            }
          }
        }
      });
    },    
    settingsTripSelect(trip) {
      //this.$refs.childPaymentList.refreshData(0);
      this.setCurrentTrip(trip.id);
      this.showPage(2);
      this.configSave();
    },
    settingsSave(trip) {
      apiPush({method:'_alt_trip', trip: trip.id, name: trip.name},'trip_'+this.currentTrip.id);
    },
    docDialogAgree(idx) {
      let doc = this.agreements[idx];
      this.modalDialog({
        title: this.$t(doc.title),
        body: ((this.locale == 1) ? '' : this.$t(doc.body)) + this[doc.text],
        close: () => {
          this.dialogInfo.title = '';
          this.dialogInfo.body = '';
          this.dialogInfo.model = false;
        }
      });  
      /*
      if((this.masterMode > 0)) {                       // Принятие документа - будет когда нибудь
        this.dialogInfo.okTitle = this.$t('doc.agree');                  
        this.dialogInfo.ok = () => {
          this.callApi('_agree',{doc: doc.type}).then( () => {
            this.dialogInfo.model = false;
            this.dialogInfo.ok = null;
          });
        };
      } else {
        this.dialogInfo.ok = null;        
      }
      */
    },
    makeXls() {
      this.callApi('_xls',{trip: this.config.currentTrip, lang: this.locales[this.locale].text, payments: this.payTable}).then(result => {
        if(result) {
          let body = '<h3>'+this.$t(result.left ? 'message.trips.xlsInfo' : 'message.trips.xlsInfo1');
          if(!result.left) {
            body += '<br/>'+this.$tc('message.trips.waitTime', result.waitH);
            if(result.waitM) {
              body += ' '+this.$tc('message.trips.waitTimeM', result.waitM);
            }
            body += '.';
          }
          body += '</h3>';
          this.modalDialog({
            title: this.$t('message.trips.xls'),
            body: body
          });
        }
      });
    },
    deleteTrip(id) {
      let trip = this.getTripById(id);
      this.modalDialog({
        title: this.$t(trip.slave ? 'message.trips.delSlave' : 'message.trips.delMaster'),
        body: '<h3>'+this.$t(trip.slave ? 'message.trips.delSlaveInfo' : 'message.trips.delMasterInfo')+'</h3>',
        okTitle: 'Ok',
        ok: () => {
          this.dialogInfo.model = false;
          //this.$refs.childPaymentList.refreshData(0);
          this.$nextTick(() => {
            if(trip.slave) {
              this.vConsoleTo('Trip del (slave) 1',3);
              this.deleteSlave(trip.slave);
            } else {
              this.vConsoleTo('Trip del (master) 1',3);
              this.deleteTripSubmit(id);         
            }
          });
        }
      });
    },
    deleteSlave(slave) {
      this.tripObserver = false;
      let idx = this.config.slaves.findIndex((sl) => {
        return sl.slave == slave;
      });
      if(idx != -1) {
        this.config.slaves.splice(idx, 1);
        this.loadTrips().then((ok) => {         
          this.tripObserver = true;
          let nextTrip = 0;
          this.$nextTick(() => {
            if(ok && this.trips.length) {
              nextTrip = this.trips[this.trips.length-1].id;
            }
            this.vConsoleTo('New (next) current trip (slave only): '+nextTrip,3);
            this.setCurrentTrip(nextTrip, true);
            this.configSave().then(() => {
              this.appRefresh();
            });
          });
        },() => {});        
      }
    },
    deleteTripSubmit(id) {
      this.tripObserver = false;
      let nextTrip = 0;
      this.callApi('_del_trip',{trip: id}).then(result => {
        this.vConsoleTo('Trip deleted',3);
        if(result) {
          this.setCurrentTrip(0);      // Потому что старого trip уже нет. Для delSlave это не проблема
          this.vConsoleTo('Loading trips after deletion',3);
          this.loadTrips().then((ok) => {
            this.vConsoleTo('Trips reloaded',3);
            if(ok) {
              this.tripObserver = true;
              this.$nextTick(() => {
                if(this.trips.length) {
                  nextTrip = this.trips[this.trips.length-1].id;
                }
                this.vConsoleTo('New (next) current trip (permanent): '+nextTrip, 3);
                this.setCurrentTrip(nextTrip, true);
                this.configSave().then(() => {
                  this.$refs.childSettings.setCurrentTrip(false);
                });
              });
            }
          },() => {});
        }
      });      
    },
    addNewTrip() {
      this.tripObserver = false;
      this.callApi('_add_trip',{name: 'New trip'}).then(result => {
        if(result) {
          this.loadTrips().then((ok) => {
            if(ok) {
              this.tripObserver = true;
              this.$nextTick(() => {
                this.showPage(2);
                this.setCurrentTrip(result.id);
                this.configSave().then(() => {
                  this.$refs.childSettings.setCurrentTrip(true);  
                });
              });
            }
          },() => {});
        }
      });
    },
    cons() {
      this.vConsoleWebAllow = !this.vConsoleWebAllow;
      this.config.console = this.vConsoleWebAllow;
      this.configSave();
    },
    wipeAccount(force = false) {
      if(force) {
        this.callApi('_wipe',{name: 'New trip'}).then(result => {
          if(result) {
            apiUnsubscribe();
            this.wipe();
          }
        });
      } else {
        apiUnsubscribe();
        this.wipe();        
      }
    },
    defLocale() {   // Default locale
      switch(CDLocale.language) {
        case 'UA':
        case 'ua':
          this.config.locale = 1;
          break;
        case 'RU':
        case 'ru':
          this.config.locale = 2;
          break;
        default:
          this.config.locale = 0;
          break;              
      }
    },
    wipe(force = true) {
      this.config = defs.config;
      if(cordovaApp) {
          this.defLocale();
      } else {
        this.config.uuid = this.createUuid();
      }    
      if(force) {
        if(webApp) {      // webApp
          window.localStorage.clear();  // removeItem('config');
          this.vConsoleTo('WIPE localStorage and refresh',3);
          this.appRefresh();
        } else {
          this.configSave().then(() => {
            this.vConsoleTo('WIPE refresh',3);
            this.appRefresh();
          });
        }
      }
    },
    apiCheck() {
      let method = '_get_data';
      let data = {trip: 118};
      this.callApi(method, data).then((result) => { 
        this.apiCheckInfo = JSON.stringify(result);
      }); 
    },
    // Dialog openers  
    openDialogNewPayment() {
      this.drawer = false;      
      this.showPage(2, true);
      this.formAdd++;
    },    
    openDialogSettings() {
      this.drawer = false;      
      this.formSetings++;
    }, 
    openDialogAccount() {
      this.drawer = false;
      this.revenueCatPacks = [];
      if(this.config.master) {
        this.callApi('_get_prices',{}, true, false).then((result) => {
          if(result) {
            this.vConsoleTo('Getting prices: ' + JSON.stringify(result),3);
            if(cordovaApp && (result.vendor == 0)) {    // RevenueCat Pay
              this.revenueCatInit();
              // Add Error records as Google prices
              result.existing.price = null;
              if(result.existing.gpProduct) {
                result.existing.gpPrice = 'Error loading';
              }
              result.tarifs.forEach((tarif, idx) => {
                result.tarifs[idx].price = null;
                result.tarifs[idx].gpPrice = 'Error loading';
              });
              this.revenueCat.getOfferings((offerings) => {
                if(offerings.current !== null && offerings.current.availablePackages.length !== 0) {  
                  this.vConsoleTo('Google prices: ' + JSON.stringify(offerings.current.availablePackages),3);   // Перебираем пакеты от RevenueCat
                  // Add prices from Google
                  this.revenueCatPacks = offerings.current.availablePackages;
                  result.tarifs.forEach((tarif, idx) => {
                    offerings.current.availablePackages.forEach((product) => {
                      if(tarif.gpProduct == product?.product?.identifier) {
                        this.revenueCatPacks[tarif.id] = {
                          name : product.product.identifier,
                          price : product.product.price,
                          currency : product.product.currencyCode
                        };
                        result.tarifs[idx].gpPrice = product.product.price+' '+product.product.currencyCode;  // Price from Google
                        if(tarif.value == result.current) {
                          result.existing.gpPrice = result.tarifs[idx].gpPrice;                               // Current pack price by Google
                        }
                      }
                    });
                  });
                  this.vConsoleTo('Stored prices: ' + JSON.stringify(this.revenueCatPacks),3);
                  this.apiBusyTrigger = false;
                  this.apiBusy = false;
                  this.account = result;
                  this.formAccount++;
                }
              },()=>{
                // Let be Errors as prices
                this.account = result;
                this.apiBusyTrigger = false;
                this.apiBusy = false;
                this.formAccount++;
              });
            } else {                                    // Liqpay
              this.account = result;
              this.apiBusyTrigger = false;
              this.apiBusy = false;
              this.formAccount++;
            }
          }
        });
      } else {
        this.account = defs.account;
        this.formAccount++;
      }
    },            
    openDialogCurrencys() {
      this.drawer = false;      
      this.formCurrencys++;
    },    
    openDialogTravellers() {
      this.drawer = false;      
      this.formTravellers++;
    },
    openDialogRefund(pay) {
      this.vConsoleTo('Refund event',3);
      let payment = structuredClone(this.payments[pay.idx]);
      payment.transaction = this.getTransactionById(pay.subtype);
      payment.id = pay.idx;
      // payment.balance = pay.balance;      
      this.payToRefund = payment;
      this.formRefund++;
      this.vConsoleTo('Form refund opened',3);
    },
    dialogInfoClose() {
      this.dialogInfo.model = false;
    },
    dialogsPayments(event) {
      this.formsPayments = event;
    },
    closeAllDialogs()  {
        this.drawer = false;
        this.formCurrencys = false;
        this.formTravellers = false;
        // this.formsPayments    
        this.formSetings = false;
        this.formAccount = false;
        this.formAdd = false;
        this.dialogInfo.model = false;
        this.dialogLiqpay.model = false;
        this.dialogLiqpayd.model = false;
    },    
    dialogReadonlyRetry() {
      if(this.refreshApiTrigger) {
        this.vConsoleTo('Dialog Readonly Retry refresh',3);
        this.appRefresh();
      } else {
        this.apiOn();
      }
    },
    readonlyAlert() {
      this.dialogReadonly = this.dataReadonly;
    },  
    onScrollList() {
      this.scrollList = true;
      if(this.scrollListTimer) {
        window.clearTimeout(this.scrollListTimer);
      }
      this.scrollListTimer = window.setTimeout(() => {
        this.scrollList = false;
      }, this.scrollListDelay);
    },
    onResize() {
      this.compact =
        window.innerWidth < 390
          ? 4
          : window.innerWidth < 600
          ? 3
          : window.innerWidth < 960
          ? 2
          : window.innerWidth < 1264
          ? 1
          : 0;
      this.onScrollList();
    },
    dialogShowInfo() {    // Показывет и скрывает текст подсказки в активном диалоговом окне
      if(this.formCurrencys) {
        this.$refs.childCurrencyEdit.toggleInfo();
      }
      if(this.formTravellers) {
        this.$refs.childTravellersEdit.toggleInfo();
      }
      if(this.formSetings) {
        this.$refs.childSettings.toggleInfo();
      }
      if(this.formAccount) {
        this.$refs.childAccount.toggleInfo();
      }
      if(this.formAdd) {
        this.$refs.childPaymentAdd.toggleInfo();
      }
      if(this.formRefund) {
        this.$refs.childPaymentRefund.toggleInfo();
      } 
      if(this.formsPayments) {
        this.$refs.childPaymentList.toggleInfo();
      }            
    },
    modalDialog(data) {
      this.vConsoleTo('Dialog data: '+JSON.stringify(data),0);
      this.dialogInfo = {
        model: false,
        title: '',
        body: '',
        okTitle: 'Ok',
        okIcon: null,
        ok: null,
        close: () => {
          this.dialogInfo.model = false;
        },
        open: null,
        closeTitle: null};
      for(let key in data) {
        this.dialogInfo[key] = data[key];
      }
      this.dialogInfo.model = true;
      if(this.dialogInfo.open) {
        window.setTimeout(()=>{
          this.dialogInfo.open();
        }, 600);
      }
    },

    // for payTable
    getTransactionById(id) {
      id = parseInt(id);
      let a = [1, 2, 4, 5, 6, 8, 9, 11, 12];
      let b = [0, 1];
      return id <= a.length
        ? this.transactions[a[id - 1]]
        : this.transactionsRefund[b[id - 10]];
    },
    shemaPartsNormalise(shema, sum) {
      let result = [];
      shema.forEach((elem) => {
        result.push( {part:elem, parts:sum} );
      });
      return result;
    }, 
    byMatrix(code, part) {
      return (
        (code & 1 ? part : 0) +
        (code & 2 ? 1 : 0) +
        (code & 4 ? -part : 0) +
        (code & 8 ? -1 : 0) +
        (code & 16 ? part : 0) +
        (code & 32 ? 1 : 0) +
        (code & 64 ? -part : 0) +
        (code & 128 ? -1 : 0)
      );
    },
    payTableCreate() {
      let firsttime = true;
      let table = [];
      let names = [];
      let totalBudget = 0;
      let wallet = 0;
      let balance = new Array(this.travellers.length - 1);
      let debet = new Array(this.travellers.length - 1);
      let credit = new Array(this.travellers.length - 1);
      let permanentPays = [];
      let permanentUsers = new Array(this.travellers.length);
      let permanentCurrencys = new Array(this.currencys.length);
      permanentCurrencys.fill(false);
      permanentUsers.fill(false);
      this.travellers.forEach((traveller, idx) => {
        if (idx) {
          names.push(traveller.name);
        }
      });
      if (this.payments.length) {
        this.payments.forEach((pay, idx) => {
          if (typeof pay.amount != "undefined") {
            let transaction = this.getTransactionById(pay.subtype);
            let receiver = 0;
            let amount = pay.amount * pay.rate;
            let shema = [];
            let shemaIcon = null;
            let card_tab = this.matrix[this.privateBudget ? 2 : 3][this.getMatrix[pay.subtype]];
            let card_bal =
              this.matrix[this.privateBudget ? 0 : 1][
                this.getMatrix[pay.subtype]
              ];

            let payShema =
              pay.shemaLink >= 0
                ? this.payments[pay.shemaLink].shema
                : pay.shema;
            let payShemas = structuredClone(
              pay.shemaLink >= 0
                ? this.payments[pay.shemaLink].shemas
                : pay.shemas);
            if (pay.shemaLink >= 0 && !permanentPays.includes(pay.shemaLink)) {
              permanentPays.push(pay.shemaLink);
            }
            if (
              typeof card_tab != "undefined" &&
              typeof card_bal != "undefined"
            ) {
              if (payShema == 3) {
                shema = payShemas;
                shemaIcon = "mdi-tune";
              } else {
                let shema_id = 0;
                if (typeof payShema != "undefined") {
                  shema_id = payShema;
                }
                this.travellers.forEach((traveller, id) => {
                  if (id && traveller.shema) {
                    shema.push(parseInt(traveller.shema[shema_id]));
                  }
                });
                shemaIcon = payShema
                  ? payShema == 1
                    ? "mdi-alpha-a-circle"
                    : "mdi-alpha-b-circle"
                  : null;
              }
              if (pay.type != 1) {
                shemaIcon = null;
              }
              let shemaSum = shema.reduce(
                (shemaS, a) => parseInt(shemaS) + ((a === null) ? 0 : parseInt(a)), 0
              );
              if(!shemaSum)
                shemaSum = 1;
              permanentCurrencys[pay.currency] = true;
              let buh = {
                names: names,
                shemaPart: this.shemaPartsNormalise(shema, shemaSum),
                in: new Array(this.travellers.length - 1),
                debetN: new Array(this.travellers.length - 1),
                creditN: new Array(this.travellers.length - 1),
                debet: new Array(this.travellers.length - 1),
                credit: new Array(this.travellers.length - 1),
                out: new Array(this.travellers.length - 1),
                outAmount: new Array(this.travellers.length - 1),                
                color: new Array(this.travellers.length - 1),
                tcolor: new Array(this.travellers.length - 1),
                // private: pay.type == 4 ? true : false,
                private: transaction.private ? true : false,
                refund: pay.type == 2 ? true : false,
                allowsRefund: (transaction.refundTransaction == null) ? false : true // pay.type == 1 ? true : (transaction.allowsRefund ? true : false),
              };
              this.travellers.forEach((traveller, id) => {
                if (id) {
                  if (firsttime) {
                    balance[id - 1] = 0;
                    credit[id - 1] = 0;
                    debet[id - 1] = 0;
                  }
                  buh.color[id - 1] = this.userColors[id - 1];
                  buh.tcolor[id - 1] = traveller.color ? defs.colorPalette.colors[traveller.color-1] : null;
                  shema[id - 1] = parseFloat(shema[id - 1]) / shemaSum;
                  buh.in[id - 1] =
                    parseFloat(balance[id - 1]).toFixed(2) +
                    "\xa0" +
                    this.ballanceCurrency.name;
                  if (pay.type == 3 && shema[id - 1] > 0) {
                    receiver = id;
                  }
                  if (pay.payer == id) {
                    buh.credit[id - 1] =
                      Math.abs(amount) *
                      this.byMatrix(card_tab[1], shema[id - 1]);
                    buh.creditN[id - 1] =
                      Math.abs(amount) *
                      this.byMatrix(card_bal[1], shema[id - 1]);                      
                    buh.debet[id - 1] =
                      Math.abs(amount) *
                      this.byMatrix(card_tab[0], shema[id - 1]);
                    buh.debetN[id - 1] =
                      Math.abs(amount) *
                      this.byMatrix(card_bal[0], shema[id - 1]);
                    credit[id - 1] += buh.creditN[id - 1] ;                      
                    debet[id - 1] += buh.debetN[id - 1];
                  } else {
                    buh.creditN[id - 1] =
                      Math.abs(amount) *
                      this.byMatrix(card_bal[3], shema[id - 1]);                      
                    buh.debetN[id - 1] =
                      Math.abs(amount) *
                      this.byMatrix(card_bal[2], shema[id - 1]);
                    credit[id - 1] += buh.creditN[id - 1];                      
                    debet[id - 1] += buh.debetN[id - 1];
                  }
                  if (
                    buh.creditN[id - 1] ||
                    buh.debetN[id - 1] ||
                    credit[id - 1] ||
                    debet[id - 1]
                  ) {
                    permanentUsers[id] = true;
                  }
                  balance[id - 1] =
                    parseFloat(balance[id - 1]) +
                    buh.creditN[id - 1] -
                    buh.debetN[id - 1];
                  buh.outAmount[id - 1] = parseFloat(balance[id - 1]);
                  buh.out[id - 1] =
                    parseFloat(balance[id - 1]).toFixed(2) +
                    "\xa0" +
                    this.ballanceCurrency.name;
                }
              });
              firsttime = false;
              if(transaction.wallet)    // баланс кошелька
              {
                wallet += parseFloat(amount);
              }
              if(!transaction.privateOnly || this.privateBudget) {
                table.push({
                  date: pay.date,
                  dateB: pay.date.substring(0, 6) + pay.date.substring(8, 10),
                  dateA: pay.date.substring(0, 10),
                  time: pay.date.substring(11, 16),
                  icon: pay.icon ? this.lbls[pay.icon - 1].icon : "",
                  theme: pay.icon,
                  shemaLink: (pay.shemaLink >= 0) ? pay.shemaLink : -1,
                  themeLink: (pay.shemaLink >= 0) ? this.payments[pay.shemaLink].icon : (transaction.iconLink ? transaction.iconLink : null), 
                  shema: shemaIcon,
                  payer: pay.payer,
                  receiver: receiver,
                  name: this.travellers[pay.payer].name,
                  name2: receiver ? this.travellers[receiver].name : "",
                  amount:
                    pay.amount + "\xa0" + this.currencys[pay.currency].name,
                  balanceAmount:
                    amount.toFixed(2) + "\xa0" + this.ballanceCurrency.name,
                  rate: pay.rate,
                  budjet: transaction.budjet,
                  currencyId: pay.currency,
                  currencyName: this.currencys[pay.currency].name,
                  balanceCurrency: this.ballanceCurrency,
                  memo: pay.memo,
                  idx: idx,
                  subtype: pay.subtype,
                  subtypeText: transaction.text,         // this.getTransactionById(pay.subtype).text, // ?????
                  balance: structuredClone(buh),
                });
              }
            }
          }
        });
        if (table.length) {
          let debetTx = [];
          let creditTx = [];
          debet.forEach((db, id) => {
            debetTx[id] = db.toFixed(2) + "\xa0" + this.ballanceCurrency.name;
            totalBudget += db;
          });
          credit.forEach((db, id) => {
            creditTx[id] = db.toFixed(2) + "\xa0" + this.ballanceCurrency.name;
          });
          table[table.length - 1].totalBudgetAmount = totalBudget;
          table[table.length - 1].balanceCurrency = this.ballanceCurrency.name;
          table[table.length - 1].totalBudget =
            totalBudget.toFixed(2) + "\xa0" + this.ballanceCurrency.name;
          table[table.length - 1].totalDebetAmount = debet;
          table[table.length - 1].totalCreditAmount = credit;
          table[table.length - 1].totalDebet = debetTx;
          table[table.length - 1].totalCredit = creditTx;          
          table[table.length - 1].permanentCurrencys = permanentCurrencys;
          table[table.length - 1].permanentUsers = permanentUsers;
          table[table.length - 1].permanentPays = permanentPays;
          table[table.length - 1].walletAmount = wallet;
          table[table.length - 1].wallet = wallet.toFixed(2) + "\xa0" + this.ballanceCurrency.name;
          
          this.balance.totalBudgetAmount = totalBudget;
          this.balance.totalBudget = totalBudget.toFixed(2) + "\xa0" + this.ballanceCurrency.name;
          this.balance.totalDebet = debet;
          this.balance.totalCredit = credit;
          this.balance.permanentCurrencys = permanentCurrencys;
          this.balance.permanentUsers = permanentUsers;
          this.balance.permanentPays = permanentPays;
          this.balance.walletAmount = wallet;
          this.balance.wallet = wallet.toFixed(2) + "\xa0" + this.ballanceCurrency.name;
        }
      }
      this.payTable = table.reverse();
    }
  },
  watch: {
    snackbarAddPaymentAllowed: {
      handler(value) {
        if(value)
          this.onScrollList();
      }
    },
    drawer: {
      handler(value) {
        if(!value) {
          this.onScrollList();
        }
        let elem = document.getElementById('drw-'+this.config.page);
        if(elem) {
          elem.classList.add('vf-list-active');
        }
      }
    },
    privateBudget: {
      handler() {
        this.payTableCreate();
      }
    }
  }
};
</script>
<style>
.vf-add-payment {
  color: white;
  font-size: 1.1em !important;  
  font-weight: bold;  
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
  opacity: 0;
}
.fm-menu {
  font-size: 1.4em;
  color: blue;
}
.fm-menu-api {
  font-size: 1.4em;
  color: green;
}
.footer-text {
  font-size: 0.8em;
}
span.trip-name {
  color: green;
}
p.doc {
  font-weight: normal;
  font-size: 1em;
  line-height: 120%;
  margin: 0.7em 0 0 0;
}
h2.doc {
  font-weight: bold;
  font-size: 1.2em;
  line-height: 120%;
  margin: 1em 0 0 0;  
}
#v-console {
  font-size: 0.8em;
  margin: 0 5px 0 5px;  
}
.vf-list-active {
  background-color: #E3F2FD !important;
}
.pointer {
  cursor: pointer;
}
table.table {
  margin-top: 10px;
  width: 100%;
}
th.table-r {
  width: 50%;
  text-align: right;
  padding: 4px;
  border-bottom: 1px solid #e0e0e0;
}
th.table-l {
  width: 50%;
  text-align: left;
  padding: 4px;
  border-bottom: 1px solid #e0e0e0;
}
.tripcount-logo {
  color: #1976D2 !important;
  font-style: italic;
  font-weight: bold;
  letter-spacing: 0.5em;
}
</style>